













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import StageUpdateModal from '@/app/components/FieldDetails/StageUpdateModal.vue'
import GraphDialog from '@/app/components/FieldDetails/GraphDialog.vue'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'
import { harvestStatus } from '@/app/model/store/domain/const'
/* pulugin */
import * as ChartAnnotation from 'chartjs-plugin-annotation'
import * as ChartDraggable from 'chartjs-plugin-draggable'
/* api */
import GetLinkImgApi from '@/app/model/api/getLinkImgApi'
import GetNewsBoardFileApi from '@/app/model/api/getNewsBoardFileApi'
import newsBoardContentsListApi from '@/app/model/api/newsBoardContentsListApi'
import GetExternalLinkFileApi from '@/app/model/api/getExternalLinkFileApi'
import ExternalLinkContentsListApi from '@/app/model/api/externalLinkContentsListApi'

@Component({
  components: {
    Graph: () => import('@/app/components/FieldDetails/Graph.vue'),
    StageUpdateModal,
    GraphDialog
  }
})
export default class FieldGraph extends Vue {
  private isActive: boolean = false
  private label: any[] = []
  private showStageUpdateModal: boolean = false
  private showDetailsDialog: boolean = false
  private showAreaChart: boolean = true
  private showTemparatureChart: boolean = false
  private showSolarRadationChart: boolean = false
  private showTemperatureChart: boolean = false
  private showWeedGrowthChart: boolean = false
  private stageDate: string = ''
  private growthData: {[key: string]: string|number|any} = {}
  private dialogTop: string = '0px'
  private dialogLeft: string = '0px'
  private graphMaxDay: any = ''
  private slideWidth: number = 0
  private slideTop: number = 35
  private slideRangeLineTop: number = 20
  private weedSlideRangeLineTop: number = 53
  private slide: number = 0
  public chartData: any = {}
  public areaChartData: any = {}
  public predictionChartData: any = {}
  public solarRadationChartData: any = {}
  public temperatureChartData: any = {}
  public temperatureDifferenceChartData: any = {}
  public weedGrowthChartData: any = {}
  private checkboxData: {[key: string]: string|boolean}[] = []
  private imageRecordsData: any[] = []
  private imageData: any[] = []
  private pointIconsData: any[] = []
  private pointIconData: any[] = []
  private isPlantingIcon: boolean = true
  private showPlantingLink: boolean = false
  private cameraIcon: any = require('@/assets/icon/camera_icon.svg')
  private sicknessIcon: any = require('@/assets/icon/ico_sick_select@2x.png')
  private weedsIcon: any = require('@/assets/icon/ico_weed_select@2x.png')
  private pestIcon: any = require('@/assets/icon/ico_pest_select@2x.png')
  private highTemperatureIcon: any = require('@/assets/icon/ico_temperature_select@2x.png')
  private fallenFruitIcon: any = require('@/assets/icon/ico_fall_select.png')
  private otherRiskIcon: any = require('@/assets/icon/ico_condition_select@2x.png')
  private riskRecordsData: any[] = []
  private riskData: any = []
  private riskDetailData: any[] = []
  private showRiskDialogFlag: boolean = false
  private hoverIndex: number = 0
  private harvestStatus: number = 0
  private harvestStatusName: string= ''
  private harvestStatusUpdateData: any|null = ''
  private harvestStatusPosition: number = 0
  private showHarvestStatus: boolean = false
  private isFinishied: boolean = false
  public displayWaterData: any = {}
  private temperatureYMax: number = 5000
  private elementYMax: number = 7000
  private elementYMax1: number = 7000
  private elementYMax2: number = 7000
  private elementYMax3: number = 7000
  private elementYMax4: number = 7000
  private weedGrowthYMax: number = 150
  private fieldId = ''
  private plantingId = ''
  private newsBoardTitle: string = ''
  private externalLinkTitle: string = ''
  private constantValue: any

  public chartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul class="' + chart.id + '-legend">')
      // 配列の順番設定用
      const legendSort = ['実績積算温度(℃)', '比較積算温度(℃)', '目標積算温度(℃)', '予測積算温度(℃)']
      for (let i = 0; i < 12; i++) {
        let labelText
        if (i <= 2) {
          if (process.env.VUE_APP_ELEMENT1_UNIT === '') {
            labelText = process.env.VUE_APP_ELEMENT1_NAME
          } else {
            labelText = process.env.VUE_APP_ELEMENT1_NAME + '(' + process.env.VUE_APP_ELEMENT1_UNIT + ')'
          }
        } else if (i <= 5) {
          if (process.env.VUE_APP_ELEMENT2_UNIT === '') {
            labelText = process.env.VUE_APP_ELEMENT2_NAME
          } else {
            labelText = process.env.VUE_APP_ELEMENT2_NAME + '(' + process.env.VUE_APP_ELEMENT2_UNIT + ')'
          }
        } else if (i <= 8) {
          if (process.env.VUE_APP_ELEMENT3_UNIT === '') {
            labelText = process.env.VUE_APP_ELEMENT3_NAME
          } else {
            labelText = process.env.VUE_APP_ELEMENT3_NAME + '(' + process.env.VUE_APP_ELEMENT3_UNIT + ')'
          }
        } else {
          if (process.env.VUE_APP_ELEMENT4_UNIT === '') {
            labelText = process.env.VUE_APP_ELEMENT4_NAME
          } else {
            labelText = process.env.VUE_APP_ELEMENT4_NAME + '(' + process.env.VUE_APP_ELEMENT4_UNIT + ')'
          }
        }

        if (i === 0 || i === 3 || i === 6 || i === 9) {
          labelText = '実績' + labelText
        } else if (i === 1 || i === 4 || i === 7 || i === 10) {
          labelText = '比較' + labelText
        } else {
          labelText = '目標' + labelText
        }

        legendSort.push(labelText)
      }
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      for (var i = 0; i < items.length; i++) {
        // 凡例のテキストがない場合
        if (items[i].text === undefined) {
          text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
          if (items[i]) {
            text.push(items[i].text)
          }
          text.push('</span></li>')
        } else {
          // 比較データの場合は色を薄くする
          if (items[i].text.startsWith('比較')) {
            text.push('<li class="disabled"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')

            if (items[i]) {
              text.push(items[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較以外
            // hiddenのclassを付与するかどうか
            if (items[i].hidden) {
              text.push('<li class="hidden"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
            } else {
              text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
            }

            if (items[i]) {
              text.push(items[i].text)
            }
            text.push('</span></li>')
          }
        }

        if (i === 3 || i === 6 || i === 9 || i === 12) {
          text.push('</br>')
        }
      }
      text.push('</ul>')

      return 0 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '積算温度'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            max: 4000,
            stepSize: 1000
          },
          position: 'right'
        },
        {
          id: 'yAxis_default_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            labelString: process.env.VUE_APP_ELEMENT1_NAME + '・' + process.env.VUE_APP_ELEMENT2_NAME + '・' + process.env.VUE_APP_ELEMENT3_NAME + '・' + process.env.VUE_APP_ELEMENT4_NAME
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            max: 200,
            stepSize: 50,
            showLabelBackdrop: true
          },
          position: 'left'
        },
        {
          id: 'yAxis_individual_element1',
          type: 'linear',
          display: false,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: false
          },
          ticks: {
            autoSkip: true,
            suggestedMin: 10,
            suggestedMax: 50,
            stepSize: 5
          },
          position: 'left'
        },
        {
          id: 'yAxis_individual_element2',
          type: 'linear',
          display: false,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: false
          },
          ticks: {
            autoSkip: true,
            suggestedMin: 10,
            suggestedMax: 50,
            stepSize: 5
          },
          position: 'left'
        },
        {
          id: 'yAxis_individual_element3',
          type: 'linear',
          display: false,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: false
          },
          ticks: {
            autoSkip: true,
            suggestedMin: 10,
            suggestedMax: 50,
            stepSize: 5
          },
          position: 'left'
        },
        {
          id: 'yAxis_individual_element4',
          type: 'linear',
          display: false,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: false
          },
          ticks: {
            autoSkip: true,
            suggestedMin: 10,
            suggestedMax: 50,
            stepSize: 5
          },
          position: 'left'
        }
      ]
    },
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date: any
          let displayDate: any

          // 比較element1の場合
          if (tooltipItem[0].datasetIndex === 11) {
            /* 播種日同士の差分を求める */
            let plantingDay = DateClass.formingDate(Session.getPlantingDay()!)
            let comparisonPlant = DateClass.formingDate(Object.keys(JSON.parse(Session.getComparisonData()!))[0])
            let diff = plantingDay.getTime() - comparisonPlant.getTime()
            diff = Math.floor(diff / (1000 * 60 * 60 * 24))

            date = new Date(tooltipItem[0].xLabel)
            date.setDate(date.getDate() - diff)
            displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          } else {
            date = new Date(tooltipItem[0].xLabel)
            displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          }

          let today = new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月' + (new Date().getDate() - 1) + '日'
          if (displayDate === today) {
            displayDate += '(最新データ)'
          }

          return displayDate
        }
      }
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    annotation: {
      events: ['click', 'drag', 'mouseover'],
      annotations: []
    }
  }
  public areaChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      // 配列の順番設定用
      const legendSort = ['実績体積含水率(%)', '比較体積含水率(%)', '目標体積含水率(%)', '実績地温(℃)', '比較地温(℃)', '目標地温(℃)']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      var text = []
      text.push('<ul class="2-legend">')
      for (var i = 0; i < items.length; i++) {
        // 凡例のテキストがない場合
        if (items[i].text === undefined) {
          text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
          if (items[i]) {
            text.push(items[i].text)
          }
          text.push('</span></li>')
        } else {
          // 比較データの場合は色を薄くする
          if (items[i].text.startsWith('比較')) {
            text.push('<li class="disabled"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
            if (items[i]) {
              text.push(items[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較以外
            // hiddenのclassを付与するかどうか
            if (items[i].hidden) {
              text.push('<li class="hidden"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
              if (items[i]) {
                text.push(items[i].text)
              }
              text.push('</span></li>')
            } else {
              text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
              if (items[i]) {
                text.push(items[i].text)
              }
              text.push('</span></li>')
            }
          }
        }

        if (i === 2 || i === 5 || i === 8 || i === 11) {
          text.push('</br>')
        }
      }
      text.push('</ul>')

      return 1 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 28,
        bottom: 20,
        right: 28
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '体積含水率・地温'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            suggestedMax: 10,
            maxTicksLimit: 4
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: process.env.VUE_APP_ELEMENT3_NAME + '・' + process.env.VUE_APP_ELEMENT1_NAME + '・' + process.env.VUE_APP_ELEMENT4_NAME
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            min: 0,
            max: 200,
            stepSize: 50
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public temperatureChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      // 配列の順番設定用
      const legendSort = ['実績日平均気温(℃)', '比較日平均気温(℃)', '実績最高気温(℃)', '比較最高気温(℃)', '実績最低気温(℃)', '比較最低気温(℃)', '実績寒暖差(℃)', '比較寒暖差(℃)']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      var text = []
      text.push('<ul class="6-legend">')
      for (var i = 0; i < items.length; i++) {
        // 凡例作成
        text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
        // 凡例名
        text.push(items[i].text)
        text.push('</span></li>')
        if (i === 1 || i === 3 || i === 5) {
          text.push('</br>')
        }
      }
      // 改行を追加
      text.push('</ul>')

      return 6 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 28,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '気温'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            suggestedMax: 40,
            suggestedMin: -10,
            maxTicksLimit: 6
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: ''
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            suggestedMax: 1000,
            maxTicksLimit: 3
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public temperatureDifferenceChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    layout: {
      padding: {
        top: 0,
        left: 28,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '寒暖差'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            suggestedMax: 40,
            suggestedMin: 0,
            maxTicksLimit: 5
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: ''
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            suggestedMax: 1000,
            maxTicksLimit: 3
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }

  public precipitationChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul class="3-legend">')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        // 凡例のテキストがない場合
        if (chart.legend.legendItems[i].text === undefined) {
          text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
          if (chart.legend.legendItems[i]) {
            text.push(chart.legend.legendItems[i].text)
          }
          text.push('</span></li>')
        } else {
          // 比較データの場合は色を薄くする
          if (chart.legend.legendItems[i].text.startsWith('比較')) {
            text.push('<li class="disabled"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
            if (chart.legend.legendItems[i]) {
              text.push(chart.legend.legendItems[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較以外
            // hiddenのclassを付与するかどうか
            if (chart.legend.legendItems[i].hidden) {
              text.push('<li class="hidden"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            } else {
              text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            }
          }
        }

        if (i === 2 || i === 5 || i === 8 || i === 11) {
          text.push('</br>')
        }
      }
      text.push('</ul>')

      return 2 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 12,
        bottom: 20,
        right: 30
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '積算降水量(mm)'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            suggestedMax: 1000,
            maxTicksLimit: 4
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: process.env.VUE_APP_ELEMENT1_NAME + '・' + process.env.VUE_APP_ELEMENT4_NAME
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            min: 0,
            max: 200,
            stepSize: 50
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public solarRadationChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      // 配列の順番設定用
      const legendSort = ['実績日射量(MJ/m2)', '比較日射量(MJ/m2)', '予測日射量(MJ/m2)', '実績積算日射量(MJ/m2)', '比較積算日射量(MJ/m2)', '予測積算日射量(MJ/m2)']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      var text = []
      text.push('<ul class="4-legend">')
      for (var i = 0; i < items.length; i++) {
        // 凡例のテキストがない場合
        if (items[i].text === undefined) {
          text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
          if (items[i]) {
            text.push(items[i].text)
          }
          text.push('</span></li>')
        } else {
          // 比較データの場合は色を薄くする
          if (items[i].text.startsWith('比較')) {
            text.push('<li class="disabled"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
            if (items[i]) {
              text.push(items[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較以外
            // hiddenのclassを付与するかどうか
            if (items[i].hidden) {
              text.push('<li class="hidden"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
              if (items[i]) {
                text.push(items[i].text)
              }
              text.push('</span></li>')
            } else {
              text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
              if (items[i]) {
                text.push(items[i].text)
              }
              text.push('</span></li>')
            }
          }
        }

        if (i === 2 || i === 5 || i === 8 || i === 11) {
          text.push('</br>')
        }
      }
      text.push('</ul>')

      return 3 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 28,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '日射量'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            suggestedMax: 40,
            maxTicksLimit: 3
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '積算日射量'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            suggestedMax: 1000,
            maxTicksLimit: 3
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public weedGrowthChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul class="5-legend">')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        // 凡例のテキストがない場合
        if (chart.legend.legendItems[i].text === undefined) {
          text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
          if (chart.legend.legendItems[i]) {
            text.push(chart.legend.legendItems[i].text)
          }
          text.push('</span></li>')
        } else {
          // 比較データの場合は色を薄くする
          if (chart.legend.legendItems[i].text.startsWith('比較')) {
            text.push('<li class="disabled"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
            if (chart.legend.legendItems[i]) {
              text.push(chart.legend.legendItems[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較以外
            // hiddenのclassを付与するかどうか
            if (chart.legend.legendItems[i].hidden) {
              text.push('<li class="hidden"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            } else {
              text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            }
          }
        }

        if (i === 2 || i === 5 || i === 8 || i === 11) {
          text.push('</br>')
        }
      }
      text.push('</ul>')

      return 4 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 30
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '雑草丈(cm)'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            suggestedMax: 150,
            maxTicksLimit: 4
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: '果実直径・結実数'
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            min: 0,
            max: 200,
            stepSize: 50
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    annotation: {
      annotations: []
    },
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  private showStageDate: boolean = true
  private transparentColor: string = 'rgba(0,0,0,0)'

  @Prop() private plantingLinkData!: any
  private linkIcon: string = ''

  private async getLinkIcon () {
    const result = await GetLinkImgApi.getLinkImgData()
    this.linkIcon = String(result)
  }

  // 日付title表示用
  private displayDate (date: number, text: string) {
    const year = String(date).slice(0, 4)
    const month = String(date).slice(4, 6)
    const day = String(date).slice(6)

    if (text !== '') {
      return year + '年' + month + '月' + day + '日' + text
    }
    return year + '年' + month + '月' + day + '日'
  }

  private mouseOverRiskAction (index: number, details: any[]) {
    this.showRiskDialogFlag = true
    this.hoverIndex = index
    this.riskDetailData = details
    this.showDetailsDialog = false
  }
  private mouseLeaveRiskAction (index: number) {
    this.showRiskDialogFlag = false
  }

  private showNewsBoardDialogFlag = false
  private newsBoardDetailData: any[] = []
  private newsBoardHoverIndex: number = 0

  private showExternalLinkDialogFlag = false
  private externalLinkDetailData: any[] = []
  private externalLinkHoverIndex: number = 0

  private mouseOverNewsBoardAction (index: number, details: any[]) {
    this.showNewsBoardDialogFlag = true
    this.newsBoardDetailData = details
    this.newsBoardHoverIndex = index
    this.showDetailsDialog = false
  }
  private mouseLeaveNewsBoardAction () {
    this.showNewsBoardDialogFlag = false
  }

  private mouseOverExternalLinkAction (index: number, details: any[]) {
    this.showExternalLinkDialogFlag = true
    this.externalLinkDetailData = details
    this.externalLinkHoverIndex = index
    this.showDetailsDialog = false
  }
  private mouseLeaveExternalLinkAction () {
    this.showExternalLinkDialogFlag = false
  }

  // 表示設定からの表示非表示切り替え
  private displayIcon (index: number) {
    const ul: any = this.$refs.settingIconList
    const cameraIcons: any = this.$refs.cameraIconList
    const pointIcons: any = this.$refs.pointIconList
    const riskIcons: any = this.$refs.riskIconList
    const harvestStatusIcons: any = this.$refs.harvestStatusIcon
    const newsBoardIcons: any = this.$refs.newsBoardIconList
    const externalLinkIcons: any = this.$refs.externalLinkIconList
    // 撮影画像
    if (index === 1 && ul.children[0].classList.contains('hidden')) {
      ul.children[0].classList.remove('hidden')
      if (cameraIcons !== null && cameraIcons !== undefined) {
        for (let i = 0; i < cameraIcons.length; i++) {
          cameraIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 1) {
      ul.children[0].classList.add('hidden')
      if (cameraIcons !== null && cameraIcons !== undefined) {
        for (let i = 0; i < cameraIcons.length; i++) {
          cameraIcons[i].classList.add('hidden')
        }
      }
    }
    // 任意アイコン
    if (index === 2 && ul.children[1].classList.contains('hidden')) {
      ul.children[1].classList.remove('hidden')
      if (pointIcons !== null && pointIcons !== undefined) {
        for (let i = 0; i < pointIcons.length; i++) {
          pointIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 2) {
      ul.children[1].classList.add('hidden')
      if (pointIcons !== null && pointIcons !== undefined) {
        for (let i = 0; i < pointIcons.length; i++) {
          pointIcons[i].classList.add('hidden')
        }
      }
    }
    // 収穫リスク
    if (index === 3 && ul.children[2].classList.contains('hidden')) {
      ul.children[2].classList.remove('hidden')
      if (riskIcons !== null && riskIcons !== undefined) {
        for (let i = 0; i < riskIcons.length; i++) {
          riskIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 3) {
      ul.children[2].classList.add('hidden')
      if (riskIcons !== null && riskIcons !== undefined) {
        for (let i = 0; i < riskIcons.length; i++) {
          riskIcons[i].classList.add('hidden')
        }
      }
    }
    // 収穫ステータス
    if (index === 4 && ul.children[5].classList.contains('hidden')) {
      ul.children[5].classList.remove('hidden')
      harvestStatusIcons.classList.remove('hidden')
    } else if (index === 4) {
      ul.children[5].classList.add('hidden')
      harvestStatusIcons.classList.add('hidden')
    }
    // 生育ステージ日
    if (index === 6 && ul.children[6].classList.contains('hidden')) {
      ul.children[6].classList.remove('hidden')
      this.showStageDate = true
      for (let i in this.chartOptions.annotation.annotations) {
        if (i === '2' || i === '5' || i === '8' || i === '11' || i === '14' || i === '17' || i === '20' || i === '23' || i === '26' || i === '29') {
          this.chartOptions.annotation.annotations[i].label.backgroundColor = this.chartOptions.annotation.annotations[parseInt(i) - 1].label.backgroundColor
          this.chartOptions.annotation.annotations[i].label.fontColor = this.chartOptions.annotation.annotations[parseInt(i) - 1].label.fontColor
        }
      }
    } else if (index === 6) {
      ul.children[6].classList.add('hidden')
      this.showStageDate = false
      for (let i in this.chartOptions.annotation.annotations) {
        if (i === '2' || i === '5' || i === '8' || i === '11' || i === '14' || i === '17' || i === '20' || i === '23' || i === '26' || i === '29') {
          this.chartOptions.annotation.annotations[i].label.backgroundColor = this.transparentColor
          this.chartOptions.annotation.annotations[i].label.fontColor = this.transparentColor
        }
      }
    }
    const graph: any = this.$refs.graph
    if (graph !== undefined) {
      graph.updateGraph()
    }
    // 栽培かわらばん
    if (index === 5 && ul.children[3].classList.contains('hidden')) {
      ul.children[3].classList.remove('hidden')
      if (newsBoardIcons !== null && newsBoardIcons !== undefined) {
        for (let i = 0; i < newsBoardIcons.length; i++) {
          newsBoardIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 5) {
      ul.children[3].classList.add('hidden')
      if (newsBoardIcons !== null && newsBoardIcons !== undefined) {
        for (let i = 0; i < newsBoardIcons.length; i++) {
          newsBoardIcons[i].classList.add('hidden')
        }
      }
    }
    // 外部連携
    if (index === 7 && ul.children[4].classList.contains('hidden')) {
      ul.children[4].classList.remove('hidden')
      if (externalLinkIcons !== null && externalLinkIcons !== undefined) {
        for (let i = 0; i < externalLinkIcons.length; i++) {
          externalLinkIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 7) {
      ul.children[4].classList.add('hidden')
      if (externalLinkIcons !== null && externalLinkIcons !== undefined) {
        for (let i = 0; i < externalLinkIcons.length; i++) {
          externalLinkIcons[i].classList.add('hidden')
        }
      }
    }
  }

  private get getGlobalData (): any {
    return this.$store.state.setFlagState.growthDialogFlag
  }
  @Watch('getGlobalData')
  updateDialog (flag: boolean) {
    if (flag) {
      this.showGraphDialog()
      // flagリセット
      this.$store.commit('setFlagState/setGrowthDialogFlag', false)
    }
  }

  private get toggleComparison (): any {
    return this.$store.state.graphToggleState.hiddenComparisonData
  }
  @Watch('toggleComparison')
  hiddenToggleGraph (flag: boolean) {
    if (flag) {
      this.displayGraph()
    }
  }

  private get comparisonPlant (): any {
    return this.$store.state.setFlagState.comparisonPlantFlag
  }
  private get comparisonMaster (): any {
    return this.$store.state.setFlagState.comparisonMasterFlag
  }
  @Watch('comparisonPlant')
  updateComparison (flag: boolean) {
    if (flag && this.$store.state.setFlagState.comparisonMasterFlag) {
      if (!this.isInit) {
        this.updateDisplayYear()
      }
      this.$store.commit('setFlagState/setComparisonPlantFlag', false)
      this.$store.commit('setFlagState/setComparisonMasterFlag', false)
    }
  }
  @Watch('comparisonMaster')
  updateComparison2 (flag: boolean) {
    if (flag && this.$store.state.setFlagState.comparisonPlantFlag) {
      if (!this.isInit) {
        this.updateDisplayYear()
      }
      this.$store.commit('setFlagState/setComparisonMasterFlag', false)
      this.$store.commit('setFlagState/setComparisonPlantFlag', false)
    }
  }

  private isInit: boolean = true

  // スライドバーの更新
  private get fieldDeatilsState (): number {
    return this.$store.state.dateChoiceState.changeDate
  }
  @Watch('fieldDeatilsState')
  onChangeKeydate (newVal: string) {
    this.changeSlideberPosition()
  }

  private changeSlideberPosition () {
    if (this.label.length !== 0) {
      const fiestDay: any = '' + this.label[0].getFullYear() + DateClass.toDoubleDigits(this.label[0].getMonth() + 1) + DateClass.toDoubleDigits(this.label[0].getDate())
      const date = DateClass.daysCalculation(parseInt(fiestDay), parseInt(this.$store.state.dateChoiceState.changeDate))

      this.slide = date
    }
  }

  private changeImageModal (date: any) {
    this.$store.commit('fieldDetailsState/setImgDate', date.record_date)
    this.$store.commit('setFlagState/setImgFlag', true)
  }

  private weedGrowthData: any = {
    new_weeding_completed_date: null,
    weed_grwoth_master: [],
    pre_weed_growths: [],
    weed_growths: [],
    alarm_value: [],
    machine_rent: []
  }

  private get openGraphSettingFlag (): boolean {
    return this.$store.state.setFlagState.openSettingModalFlag
  }
  @Watch('openGraphSettingFlag')
  getGraphCheckbox (flag: boolean) {
    if (flag) {
      // チェックボックス情報
      const data = [
        {
          label: '積算温度',
          value: 'integrationTemperature',
          checked: this.checkHidden([
            this.chartData.datasets[0].hidden,
            this.chartData.datasets[1].hidden,
            this.chartData.datasets[2].hidden,
            this.chartData.datasets[3].hidden
          ], true)
        },
        {
          label: process.env.VUE_APP_ELEMENT1_NAME,
          value: 'element1',
          checked: this.checkHidden([
            this.chartData.datasets[13].hidden,
            this.chartData.datasets[14].hidden,
            this.chartData.datasets[15].hidden
          ], true)
        },
        {
          label: process.env.VUE_APP_ELEMENT2_NAME,
          value: 'element2',
          checked: this.checkHidden([
            this.chartData.datasets[4].hidden,
            this.chartData.datasets[5].hidden,
            this.chartData.datasets[6].hidden
          ], true)
        },
        {
          label: process.env.VUE_APP_ELEMENT3_NAME,
          value: 'element3',
          checked: this.checkHidden([
            this.chartData.datasets[7].hidden,
            this.chartData.datasets[8].hidden,
            this.chartData.datasets[9].hidden
          ], true)
        },
        {
          label: process.env.VUE_APP_ELEMENT4_NAME,
          value: 'element4',
          checked: this.checkHidden([
            this.chartData.datasets[10].hidden,
            this.chartData.datasets[11].hidden,
            this.chartData.datasets[12].hidden
          ], true)
        },
        {
          label: '日射量',
          value: 'solarRadation',
          checked: this.checkHidden([
            this.solarRadationChartData.datasets[0].hidden,
            this.solarRadationChartData.datasets[1].hidden,
            this.solarRadationChartData.datasets[2].hidden
          ], this.showSolarRadationChart)
        },
        {
          label: '積算日射量',
          value: 'integratedInsolation',
          checked: this.checkHidden([
            this.solarRadationChartData.datasets[3].hidden,
            this.solarRadationChartData.datasets[4].hidden,
            this.solarRadationChartData.datasets[5].hidden
          ], this.showSolarRadationChart)
        },
        {
          label: '日平均気温',
          value: 'temperature',
          checked: this.checkHidden([
            this.temperatureChartData.datasets[0].hidden,
            this.temperatureChartData.datasets[1].hidden
          ], this.showTemperatureChart)
        },
        {
          label: '最高気温',
          value: 'temperatureHighest',
          checked: this.checkHidden([
            this.temperatureChartData.datasets[2].hidden,
            this.temperatureChartData.datasets[3].hidden
          ], this.showTemperatureChart)
        },
        {
          label: '最低気温',
          value: 'temperatureLowest',
          checked: this.checkHidden([
            this.temperatureChartData.datasets[4].hidden,
            this.temperatureChartData.datasets[5].hidden
          ], this.showTemperatureChart)
        },
        {
          label: '寒暖差',
          value: 'temperatureDifference',
          checked: this.checkHidden([
            this.temperatureDifferenceChartData.datasets[0].hidden,
            this.temperatureDifferenceChartData.datasets[1].hidden
          ], this.showTemperatureChart)
        },
        {
          label: '積算降水量',
          value: 'soilStatus',
          checked: this.checkHidden([
            this.predictionChartData.datasets[0].hidden,
            this.predictionChartData.datasets[1].hidden,
            this.predictionChartData.datasets[2].hidden
          ], this.showTemparatureChart)
        },
        {
          label: '雑草丈',
          value: 'weedGrowth',
          checked: this.checkHidden([
            this.weedGrowthChartData.datasets[0].hidden,
            this.weedGrowthChartData.datasets[1].hidden,
            this.weedGrowthChartData.datasets[2].hidden
          ], this.showWeedGrowthChart)
        },
        {
          label: '体積含水率',
          value: 'waterContainRate',
          checked: this.checkHidden([
            this.areaChartData.datasets[0].hidden,
            this.areaChartData.datasets[1].hidden,
            this.areaChartData.datasets[2].hidden
          ], this.showAreaChart)
        },
        {
          label: '地温',
          value: 'groundTemp',
          checked: this.checkHidden([
            this.areaChartData.datasets[3].hidden,
            this.areaChartData.datasets[4].hidden,
            this.areaChartData.datasets[5].hidden
          ], this.showAreaChart)
        }
      ]
      this.$store.commit('graphState/setGraphCheckbox', data)
    }
  }

  private checkHidden (array: boolean[], display: boolean) {
    if (!display) {
      return false
    }

    if (array.indexOf(false) !== -1) {
      return true
    } else {
      return false
    }
  }

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.fieldId = this.$route.params.field_id
    this.plantingId = Session.getPlantingId()!

    this.createChartData()
    this.createAreaChartData()
    this.createPrecipitationChart()
    this.createSolarRadationChart()
    this.createTemperatureChart()
    this.createTemperatureDifferenceChart()
    this.createWeedGrowthChart()
    this.getChartMaxValue()
    let growthStageList = JSON.parse(Session.getGrowthStage()!)
    this.createStageBar(growthStageList)
    if (this.plantingLinkData.planting_link !== undefined && this.plantingLinkData.planting_link !== null) {
      this.showPlantingLink = true
    }
    this.newsBoardTitle = CommonClass.getServiceFunctionData().news_board.news_board_name
    this.externalLinkTitle = CommonClass.getServiceFunctionData().external_link.external_link_name

    if (this.plantingLinkData.planting_link_icon === null) {
      this.isPlantingIcon = false
    } else {
      this.getLinkIcon()
    }

    // スライドバーの初期位置
    let graphData: any = JSON.parse(Session.getGraphData()!)
    let lastDay: any = Object.keys(graphData).pop()
    if (this.label.length !== 0) {
      const fiestDay: any = '' + this.label[0].getFullYear() + DateClass.toDoubleDigits(this.label[0].getMonth() + 1) + DateClass.toDoubleDigits(this.label[0].getDate())
      const keyDate = DateClass.daysCalculation(fiestDay, lastDay)
      this.slide = keyDate
    }

    var userAgent = window.navigator.userAgent.toLowerCase()
    // firefoxのみ開始位置が中心のためtopを変更
    if (userAgent.indexOf('firefox') !== -1) {
      this.slideTop = 264
      this.slideRangeLineTop = 74
      this.slideRangeLineTop = 107
    }
  }

  mounted () {
    window.addEventListener('resize', this.resizeWidth, false)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeWidth, false)
  }

  public resizeWidth () {
    setTimeout(this.setResizeWidth, 200)
  }

  public setResizeWidth () {
    let canvas: any = document.getElementById('line-chart')
    let canvasWidth = canvas.style.width.replace(/px/g, '')
    this.slideWidth = parseInt(canvasWidth) - 150
    this.setIcon()
    this.setWateringControl()
    this.changeNewsBoardData()
    this.changeExternalLinkData()
  }

  public setWateringControl () {
    // 潅水管理名称の表示を追加
    const waterData = []
    const oneDayWidth = (this.slideWidth - 15) / (this.label.length - 1)
    const masterWaterData = JSON.parse(Session.getMasterWateringControls()!)

    for (var i in this.label) {
      for (var j in masterWaterData) {
        const year = this.label[i].getFullYear()
        const month = '0' + (this.label[i].getMonth() + 1)
        const date = '0' + this.label[i].getDate()
        const day = '' + year + month.slice(-2) + date.slice(-2)

        if (day === String(masterWaterData[j].is_center_date)) {
          const leftPosition = parseInt(i) * oneDayWidth
          let topPosition = '0'
          if ((parseInt(j) % 2) === 0) {
            topPosition = '-5'
          } else {
            topPosition = '-25'
          }

          waterData.push({
            top: topPosition,
            left: leftPosition,
            watering_name: masterWaterData[j].watering_name
          })
        }
      }
    }
    this.displayWaterData = waterData
  }

  private setIcon () {
    this.imageRecordsData = JSON.parse(Session.getImageRecords()!)
    this.pointIconsData = JSON.parse(Session.getPointIcons()!)
    this.riskRecordsData = JSON.parse(Session.getRiskRecords()!)
    this.harvestStatus = Number(Session.getHarvestStatusData())
    this.harvestStatusUpdateData = Session.getHarvestStatusUpdateData()

    setTimeout(this.changePosition, 200)
    setTimeout(this.changeSlideberPosition, 200)
  }

  /* あい作 任意アイコンの判定 */
  private judgmentPointIcon (pointIcon: number) {
    switch (pointIcon) {
      // カメラ
      case 1:
        return require('@/assets/icon/aisaku_camera_icon.svg')

      // ★
      case 2:
        return require('@/assets/icon/black_star_icon.svg')

      // ☆
      case 3:
        return require('@/assets/icon/star_icon.svg')

      // !
      case 4:
        return require('@/assets/icon/exclamation_mark_icon.svg')

      // 不明
      default:
        return null
    }
  }

  private weedGrowthStatus: any = []
  private weedingWarning: any = []
  private weedingCompleted: any = []

  private changePosition () {
    this.imageData = []
    this.pointIconData = []
    this.riskData = []
    this.weedGrowthStatus = []
    this.weedingWarning = []
    this.weedingCompleted = []
    const updateDate = new Date(this.harvestStatusUpdateData)
    const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + DateClass.toDoubleDigits(updateDate.getDate())
    const oneDayWidth = (this.slideWidth - 25) / (this.label.length - 1)
    for (var j in this.label) {
      let year = this.label[j].getFullYear()
      let month = '0' + (this.label[j].getMonth() + 1)
      let date = '0' + this.label[j].getDate()
      let day = '' + this.label[j].getFullYear() + month.slice(-2) + date.slice(-2)

      // メイングラフ
      // 画像アイコン
      for (let i in this.imageRecordsData) {
        if (day === String(this.imageRecordsData[i].record_date)) {
          let position = parseInt(j) * oneDayWidth
          this.imageData.push({
            left: position,
            record_date: this.imageRecordsData[i].record_date
          })
        }
      }
      // 任意アイコン
      for (let i in this.pointIconsData) {
        if (day === String(this.pointIconsData[i].record_date)) {
          let position = (parseInt(j) * oneDayWidth)
          if (this.pointIconsData[i].point_icon !== null) {
            this.pointIconData.push({
              left: position,
              record_date: this.pointIconsData[i].record_date,
              icon: this.judgmentPointIcon(this.pointIconsData[i].point_icon)
            })
          }
        }
      }
      // リスクアイコン
      for (let i in this.riskRecordsData) {
        if (day === String(this.riskRecordsData[i].record_date)) {
          let position = (parseInt(j) * oneDayWidth) - 5
          let fixedIcon = false
          let riskName = '-'
          this.riskDetailData = []
          for (let k in this.riskRecordsData[i].risk_details) {
            // リスク詳細が1件かつ固定リスク(組織が設定していないリスク)の場合にtrueとリスク名をセット
            if (this.riskRecordsData[i].risk_details.length === 1 && this.riskRecordsData[i].risk_details[k].is_fixed_risk) {
              fixedIcon = true
              riskName = this.riskRecordsData[i].risk_details[k].risk_name
            }
            // リスク詳細表示用にセット
            this.riskDetailData.push({
              risk_name: this.riskRecordsData[i].risk_details[k].risk_name,
              risk_item_name: this.riskRecordsData[i].risk_details[k].risk_item_name
            })
          }
          this.riskData.push({
            left: position,
            is_fixed_icon: fixedIcon,
            risk_name: riskName,
            risk_detail_list: this.riskDetailData,
            record_date: this.riskRecordsData[i].record_date
          })
        }
      }
      if (this.harvestStatus === harvestStatus.CHANCEL || this.harvestStatus === harvestStatus.HARVESTE_INSTRUCTIONS || this.harvestStatus === harvestStatus.HARVESTED) {
        if (day === formingDate) {
          this.showHarvestStatus = true
          this.harvestStatusPosition = parseInt(j) * oneDayWidth
          this.harvestStatusUpdateData = formingDate
          if (this.harvestStatus === harvestStatus.CHANCEL) {
            this.harvestStatusName = '中止'
          } else if (this.harvestStatus === harvestStatus.HARVESTE_INSTRUCTIONS) {
            this.harvestStatusName = '収穫指示'
          } else {
            this.harvestStatusName = '収穫済み'
          }
        }
      } else {
        this.showHarvestStatus = false
      }

      // 雑草丈グラフ
      // 雑草ステータスアイコン
      if (this.weedGrowthData !== null && this.weedGrowthData.machine_rent !== null) {
        for (let k in this.weedGrowthData.machine_rent) {
          let date = this.weedGrowthData.machine_rent[k].actual_date.replace(/-/g, '')
          // ラベルの名称を判定
          let step
          if (this.weedGrowthData.machine_rent[k].is_canceled) {
            step = 0
          } else {
            step = this.weedGrowthData.machine_rent[k].machine_step
          }
          // アイコンをセット
          if (day === date && (step === 0 || step === 1 || step === 4)) {
            this.weedSlideRangeLineTop = 73
            const position = (parseInt(j) * oneDayWidth) - 5
            this.weedGrowthStatus.push({
              machine_rent_id: this.weedGrowthData.machine_rent[k].machine_rent_id,
              left: position,
              label: DateClass.dateToStringYmd(new Date(this.weedGrowthData.machine_rent[k].actual_date), '年月日') + ' ' + this.judgeWeedGrowthStatus(step)
            })
          }
        }
      }
      // 除草警報バー
      if (this.weedGrowthData !== null && this.weedGrowthData.weeding_warning !== undefined && this.weedGrowthData.weeding_warning !== null) {
        let date = this.weedGrowthData.weeding_warning.weeding_warning_date.replace(/-/g, '')
        if (day === date) {
          let position = (parseInt(j) * oneDayWidth) - 22
          this.weedingWarning.push({
            left: position,
            date: DateClass.dateToStringMd(new Date(this.weedGrowthData.weeding_warning.weeding_warning_date), '/'),
            days: this.weedGrowthData.weeding_warning.abandoned_days
          })
        }
      }
      // 除草完了バー
      if (this.weedGrowthData !== null) {
        for (let k in this.weedGrowthData.weed_growths) {
          if (this.weedGrowthData.weed_growths[k].weeding_completed !== null) {
            let date = this.weedGrowthData.weed_growths[k].weeding_completed.weeding_completed_date.replace(/-/g, '')
            if (day === date) {
              let position = (parseInt(j) * oneDayWidth) - 22
              this.weedingCompleted.push({
                left: position,
                date: DateClass.dateToStringMd(new Date(this.weedGrowthData.weed_growths[k].weeding_completed.weeding_completed_date), '/'),
                days: this.weedGrowthData.weed_growths[k].weeding_completed.abandoned_days,
                machine_rent_id: this.weedGrowthData.weed_growths[k].weeding_completed.machine_rent_id
              })
            }
          }
        }
      }
    }
  }

  private judgeWeedGrowthStatus (key: number) {
    switch (key) {
      case 1:
        return '受付'

      case 4:
        return '除草中'

      case 0:
        return 'キャンセル'

      default:
        break
    }
  }

  private dateToStringMd (date: string) {
    return DateClass.dateToStringMd(new Date(date), '月日')
  }
  private newsBoardIcons: any = []
  private externalLinkIcons: any = []

  private async getNewsBoardFile (id: number, content_name: string) {
    const objectPath: any = await GetNewsBoardFileApi.getNewsBoardFile(id)
    if (typeof objectPath === 'string') {
      const link = document.createElement('a')
      document.body.appendChild(link)
      link.href = objectPath
      link.download = content_name
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectPath)
    } else {
      Vue.prototype.$alert.toast({ text: 'ファイル取得に失敗しました。', type: 1 })
    }
  }

  private async getExternalLinkFile (id: number, content_name: string) {
    const objectPath: any = await GetExternalLinkFileApi.getExternalLinkFile(id)
    if (typeof objectPath === 'string') {
      const link = document.createElement('a')
      document.body.appendChild(link)
      link.href = objectPath
      link.download = content_name
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectPath)
    } else {
      Vue.prototype.$alert.toast({ text: 'ファイル取得に失敗しました。', type: 1 })
    }
  }

  private changeNewsBoardData () {
    let newsBoardData = this.newsBoardContents.reduce(function (rv: any, x: any) {
      (rv[x.record_date] = rv[x.record_date] || []).push(x)
      return rv
    }, {})

    for (let i in newsBoardData) {
      newsBoardData[i].sort(function (a: any, b: any) {
        // かわらばん名の昇順
        if (a.news_bord_name < b.news_bord_name) {
          return -1
        }
        if (a.news_bord_name > b.news_bord_name) {
          return 1
        }
        // 記事名の昇順
        if (a.content_name < b.content_name) {
          return -1
        }
        if (a.content_name > b.content_name) {
          return 1
        }
        return 0
      })
    }

    this.newsBoardIcons = []
    const oneDayWidth = (this.slideWidth - 25) / (this.label.length - 1)
    for (var j in this.label) {
      const year = this.label[j].getFullYear()
      const month = '0' + (this.label[j].getMonth() + 1)
      const date = '0' + this.label[j].getDate()
      const day = '' + year + '-' + month.slice(-2) + '-' + date.slice(-2)
      for (let i in newsBoardData) {
        if (day === i) {
          const position = (parseInt(j) * oneDayWidth) - 5
          const data = this.groupByCategory(newsBoardData[i])
          this.newsBoardIcons.push({
            left: position,
            record_date: year + '年' + month.slice(-2) + '月' + date.slice(-2) + '日',
            details: data,
            category_id: this.getNewsBoardCategoryId(data),
            category_name: this.getNewsBoardCategoryName(this.getNewsBoardCategoryId(data))
          })
        }
      }
    }
  }

  private getNewsBoardCategoryName (id: any) {
    for (let i in this.constantValue.news_board_categories) {
      if (this.constantValue.news_board_categories[i].category_id === id) {
        return this.constantValue.news_board_categories[i].category_name
      }
    }
    return '複数分類'
  }

  private getNewsBoardCategoryId (data: any) {
    if (Object.keys(data).length === 1) {
      for (let categoryId in data) {
        return parseInt(categoryId)
      }
    } else {
      return null
    }
  }

  private groupByCategory (data: any) {
    const list = data.reduce(function (rv: any, x: any) {
      (rv[x.category_id] = rv[x.category_id] || []).push(x)
      return rv
    }, {})

    return list
  }

  private changeExternalLinkData () {
    let externalLinkData = this.externalLinkContents.reduce(function (rv: any, x: any) {
      (rv[x.record_date] = rv[x.record_date] || []).push(x)
      return rv
    }, {})

    for (let i in externalLinkData) {
      externalLinkData[i].sort(function (a: any, b: any) {
        // 外部連携名の昇順
        if (a.external_link_name < b.external_link_name) {
          return -1
        }
        if (a.external_link_name > b.external_link_name) {
          return 1
        }
        // 連携名の昇順
        if (a.content_name < b.content_name) {
          return -1
        }
        if (a.content_name > b.content_name) {
          return 1
        }
        return 0
      })
    }

    this.externalLinkIcons = []
    const oneDayWidth = (this.slideWidth - 25) / (this.label.length - 1)
    for (var j in this.label) {
      const year = this.label[j].getFullYear()
      const month = '0' + (this.label[j].getMonth() + 1)
      const date = '0' + this.label[j].getDate()
      const day = '' + year + '-' + month.slice(-2) + '-' + date.slice(-2)
      for (let i in externalLinkData) {
        if (day === i) {
          const position = (parseInt(j) * oneDayWidth) - 5
          this.externalLinkIcons.push({
            left: position,
            record_date: month.slice(-2) + '月' + date.slice(-2) + '日',
            detail: externalLinkData[i]
          })
        }
      }
    }
  }

  private newsBoardContents: any = []
  private externalLinkContents: any = []

  private getNewsBoardContentsList () {
    (async () => {
      const data = {
        variety_id: JSON.parse(Session.getVarietyId()!),
        district_id: JSON.parse(Session.getDistrictId()!)
      }

      const result = await newsBoardContentsListApi.getNewsBoardContentsList(data)

      if (result.isOk()) {
        this.newsBoardContents = result.getPayload().news_board_contents
        this.changeNewsBoardData()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private getExternalLinkContentsList () {
    (async () => {
      const data = {
        variety_id: JSON.parse(Session.getVarietyId()!),
        district_id: JSON.parse(Session.getDistrictId()!)
      }

      const result = await ExternalLinkContentsListApi.getExternalLinkContentsList(data)

      if (result.isOk()) {
        this.externalLinkContents = result.getPayload().external_link_contents
        this.changeExternalLinkData()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  public updateDisplayYear () {
    this.isFinishied = false
    this.chartOptions.annotation.annotations = []
    this.weedGrowthChartOptions.annotation.annotations = []
    let growthStageList = JSON.parse(Session.getGrowthStage()!)

    this.createChartData()
    this.createAreaChartData()
    this.createPrecipitationChart()
    this.createSolarRadationChart()
    this.createTemperatureChart()
    this.createTemperatureDifferenceChart()
    this.createWeedGrowthChart()
    this.getChartMaxValue()
    this.createStageBar(growthStageList)
    this.displayGraph()

    this.weedGrowthData = JSON.parse(Session.getWeedGrowthData()!)
    this.createWeedCompletedBar()
    this.setIcon()
    this.setWateringControl()
    this.setTemperatureScaleYPadding()
    this.setTemperatureDifferenceScaleYPadding()

    // かわらばん情報を取得していなければAPIをたたく
    if (this.newsBoardContents.length === 0) {
      this.getNewsBoardContentsList()
    } else {
      this.changeNewsBoardData()
    }

    // 外部連携情報を取得していなければAPIをたたく
    if (this.externalLinkContents.length === 0) {
      this.getExternalLinkContentsList()
    } else {
      this.changeExternalLinkData()
    }
    this.isFinishied = true
  }

  private showUnit (unit: string) {
    return unit === '' ? '' : '(' + unit + ')'
  }

  private getShowPropriety (key: string) {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)

    if (settingData !== null) {
      return true
    } else {
      if (key === 'integrationTemperature' ||
          key === 'element1' ||
          key === 'element2' ||
          key === 'element3' ||
          key === 'element4' ||
          key === 'waterContainRate') {
        return false
      } else {
        return true
      }
    }
  }

  /* chartの基本データ */
  public createChartData () {
    const isYaxis1: string = process.env.VUE_APP_ELEMENT1_YAXIS
    const isYaxis2: string = process.env.VUE_APP_ELEMENT2_YAXIS
    const isYaxis3: string = process.env.VUE_APP_ELEMENT3_YAXIS
    const isYaxis4: string = process.env.VUE_APP_ELEMENT4_YAXIS

    this.chartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績積算温度(℃)',
          backgroundColor: '#0f6594',
          borderColor: '#0f6594',
          fill: false,
          hidden: this.getShowPropriety('integrationTemperature'),
          spanGaps: true,
          pointRadius: 0,
          pointBorderColor: this.performancePointBgColor,
          pointBackgroundColor: this.performancePointBgColor,
          data: this.createdActualResultsData('integration_temperature'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較積算温度(℃)',
          backgroundColor: '#6a9eba',
          borderColor: '#6a9eba',
          fill: false,
          hidden: this.getShowPropriety('integrationTemperature'),
          spanGaps: true,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '目標積算温度(℃)',
          backgroundColor: 'rgba(15, 101, 148, 0.3)',
          borderColor: 'rgba(15, 101, 148, 0.3)',
          fill: false,
          hidden: this.getShowPropriety('integrationTemperature'),
          spanGaps: true,
          data: this.createdGoalData('goal_integration_temperature'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '予測積算温度(℃)',
          backgroundColor: '#0f6594',
          borderColor: '#0f6594',
          fill: false,
          hidden: this.getShowPropriety('integrationTemperature'),
          spanGaps: true,
          borderDash: [5, 5],
          pointBorderColor: this.predictionPointBgColor,
          pointBackgroundColor: this.predictionPointBgColor,
          data: this.createPredictionTemperature(),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: isYaxis1 === 'true' ? 'yAxis_individual_element1' : 'yAxis_default_2',
          type: 'line',
          label: '実績' + process.env.VUE_APP_ELEMENT1_NAME + this.showUnit(process.env.VUE_APP_ELEMENT1_UNIT),
          backgroundColor: '#0B8C41',
          borderColor: '#0B8C41',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('element1'),
          data: this.createdActualResultsData('element1'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: isYaxis1 === 'true' ? 'yAxis_individual_element1' : 'yAxis_default_2',
          type: 'line',
          label: '比較' + process.env.VUE_APP_ELEMENT1_NAME + this.showUnit(process.env.VUE_APP_ELEMENT1_UNIT),
          backgroundColor: '#68B588',
          borderColor: '#68B588',
          hidden: this.getShowPropriety('element1'),
          spanGaps: true,
          fill: false,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: isYaxis1 === 'true' ? 'yAxis_individual_element1' : 'yAxis_default_2',
          type: 'bar',
          label: '目標' + process.env.VUE_APP_ELEMENT1_NAME + this.showUnit(process.env.VUE_APP_ELEMENT1_UNIT),
          backgroundColor: 'rgba(11, 140, 65, 0.3)',
          borderColor: 'rgba(11, 140, 65, 0.3)',
          barThickness: 10,
          fill: false,
          hidden: this.getShowPropriety('element1'),
          data: this.createdGoalData('goal_element1'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: isYaxis2 === 'true' ? 'yAxis_individual_element2' : 'yAxis_default_2',
          type: 'line',
          label: '実績' + process.env.VUE_APP_ELEMENT2_NAME + this.showUnit(process.env.VUE_APP_ELEMENT2_UNIT),
          backgroundColor: '#e7bf31',
          borderColor: '#e7bf31',
          hidden: this.getShowPropriety('element2'),
          fill: false,
          spanGaps: true,
          data: this.createdActualResultsData('element2'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: isYaxis2 === 'true' ? 'yAxis_individual_element2' : 'yAxis_default_2',
          type: 'line',
          label: '比較' + process.env.VUE_APP_ELEMENT2_NAME + this.showUnit(process.env.VUE_APP_ELEMENT2_UNIT),
          backgroundColor: '#f1d987',
          borderColor: '#f1d987',
          fill: false,
          hidden: this.getShowPropriety('element2'),
          spanGaps: true,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: isYaxis2 === 'true' ? 'yAxis_individual_element2' : 'yAxis_default_2',
          type: 'line',
          label: '目標' + process.env.VUE_APP_ELEMENT2_NAME + this.showUnit(process.env.VUE_APP_ELEMENT2_UNIT),
          backgroundColor: 'rgba(231, 191, 49, 0.3)',
          borderColor: 'rgba(231, 191, 49, 0.3)',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('element2'),
          data: this.createdGoalData('goal_element2'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: isYaxis3 === 'true' ? 'yAxis_individual_element3' : 'yAxis_default_2',
          type: 'line',
          label: '実績' + process.env.VUE_APP_ELEMENT3_NAME + this.showUnit(process.env.VUE_APP_ELEMENT3_UNIT),
          backgroundColor: '#31e7ba',
          borderColor: '#31e7ba',
          hidden: this.getShowPropriety('element3'),
          fill: false,
          spanGaps: true,
          data: this.createdActualResultsData('element3'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: isYaxis3 === 'true' ? 'yAxis_individual_element3' : 'yAxis_default_2',
          type: 'line',
          label: '比較' + process.env.VUE_APP_ELEMENT3_NAME + this.showUnit(process.env.VUE_APP_ELEMENT3_UNIT),
          backgroundColor: '#7EECD1',
          borderColor: '#7EECD1',
          fill: false,
          hidden: this.getShowPropriety('element3'),
          spanGaps: true,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: isYaxis3 === 'true' ? 'yAxis_individual_element3' : 'yAxis_default_2',
          type: 'line',
          label: '目標' + process.env.VUE_APP_ELEMENT3_NAME + this.showUnit(process.env.VUE_APP_ELEMENT3_UNIT),
          backgroundColor: 'rgba(49, 231, 186, 0.3)',
          borderColor: 'rgba(49, 231, 186, 0.3)',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('element3'),
          data: this.createdGoalData('goal_element3'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: isYaxis4 === 'true' ? 'yAxis_individual_element4' : 'yAxis_default_2',
          type: 'line',
          label: '実績' + process.env.VUE_APP_ELEMENT4_NAME + this.showUnit(process.env.VUE_APP_ELEMENT4_UNIT),
          backgroundColor: '#F94D83',
          borderColor: '#F94D83',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('element4'),
          data: this.createdActualResultsData('element4'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: isYaxis4 === 'true' ? 'yAxis_individual_element4' : 'yAxis_default_2',
          type: 'line',
          label: '比較' + process.env.VUE_APP_ELEMENT4_NAME + this.showUnit(process.env.VUE_APP_ELEMENT4_UNIT),
          backgroundColor: '#F68FB0',
          borderColor: '#F68FB0',
          fill: false,
          hidden: this.getShowPropriety('element4'),
          spanGaps: true,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: isYaxis4 === 'true' ? 'yAxis_individual_element4' : 'yAxis_default_2',
          type: 'line',
          label: '目標' + process.env.VUE_APP_ELEMENT4_NAME + this.showUnit(process.env.VUE_APP_ELEMENT4_UNIT),
          backgroundColor: 'rgba(249, 77, 131, 0.3)',
          borderColor: 'rgba(249, 77, 131, 0.3)',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('element4'),
          data: this.createdGoalData('goal_element4'),
          datalabels: {
            display: false
          },
          order: 4
        }
      ]
    }
  }

  public createAreaChartData () {
    this.areaChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績体積含水率(%)',
          backgroundColor: '#51B4E9',
          borderColor: '#51B4E9',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('waterContainRate'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('water_contain_rate')),
          data: this.createdActualResultsData('water_contain_rate'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較体積含水率(%)',
          backgroundColor: '#92CDED',
          borderColor: '#92CDED',
          hidden: this.getShowPropriety('waterContainRate'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '目標体積含水率(%)',
          backgroundColor: 'rgba(81, 180, 233, 0.3)',
          borderColor: 'rgba(81, 180, 233, 0.3)',
          fill: true,
          hidden: this.getShowPropriety('waterContainRate'),
          pointRadius: 0,
          spanGaps: true,
          data: this.createdGoalData('water_contain_rate'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績地温(℃)',
          backgroundColor: '#E9AC51',
          borderColor: '#E9AC51',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('groundTemp'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('ground_temp')),
          data: this.createdActualResultsData('ground_temp'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較地温(℃)',
          backgroundColor: '#EDCC92',
          borderColor: '#EDCC92',
          hidden: this.getShowPropriety('groundTemp'),
          fill: false,
          spanGaps: true,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '目標地温(℃)',
          backgroundColor: 'rgba(233, 172, 81, 0.3)',
          borderColor: 'rgba(233, 172, 81, 0.3)',
          fill: true,
          spanGaps: true,
          hidden: this.getShowPropriety('groundTemp'),
          data: this.createdGoalData('goal_ground_temp'),
          datalabels: {
            display: false
          },
          order: 3
        }
      ]
    }
  }

  public createPrecipitationChart () {
    this.predictionChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績積算降水量(mm)',
          backgroundColor: '#51B4E9',
          borderColor: '#51B4E9',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('soilStatus'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('integrated_precipitation_amount')),
          data: this.createdActualResultsData('integrated_precipitation_amount'),
          datalabels: {
            display: false
          }
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較積算降水量(mm)',
          backgroundColor: '#92CDED',
          borderColor: '#92CDED',
          hidden: this.getShowPropriety('soilStatus'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          }
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '予測積算降水量(mm)',
          backgroundColor: 'rgba(81, 180, 233, 0.3)',
          borderColor: 'rgba(81, 180, 233, 0.3)',
          fill: true,
          spanGaps: true,
          hidden: this.getShowPropriety('soilStatus'),
          data: this.createdGoalData('goal_integrated_precipitation_amount'),
          datalabels: {
            display: false
          }
        }
      ]
    }
  }

  public createSolarRadationChart () {
    this.solarRadationChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績日射量(MJ/m2)',
          backgroundColor: '#FFCE48',
          borderColor: '#FFCE48',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('solarRadation'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('solar_radation')),
          data: this.createdActualResultsData('solar_radation'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較日射量(MJ/m2)',
          backgroundColor: '#FFD972',
          borderColor: '#FFD972',
          hidden: this.getShowPropriety('solarRadation'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '予測日射量(MJ/m2)',
          backgroundColor: 'rgba(255, 206, 72, 0.3)',
          borderColor: 'rgba(255, 206, 72, 0.3)',
          fill: true,
          spanGaps: true,
          pointRadius: this.judgePointRadius(this.createdGoalData('solar_radation')),
          hidden: this.getShowPropriety('solarRadation'),
          data: this.createdGoalData('solar_radation'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績積算日射量(MJ/m2)',
          backgroundColor: '#FF8B48',
          borderColor: '#FF8B48',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('integratedInsolation'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('integrated_insolation')),
          data: this.createdActualResultsData('integrated_insolation'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較積算日射量(MJ/m2)',
          backgroundColor: '#FFA876',
          borderColor: '#FFA876',
          hidden: this.getShowPropriety('integratedInsolation'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '予測積算日射量(MJ/m2)',
          backgroundColor: 'rgba(255, 139, 72, 0.3)',
          borderColor: 'rgba(255, 139, 72, 0.3)',
          fill: true,
          spanGaps: true,
          hidden: this.getShowPropriety('integratedInsolation'),
          data: this.createdGoalData('goal_integrated_insolation'),
          datalabels: {
            display: false
          },
          order: 3
        }
      ]
    }
  }

  public createTemperatureChart () {
    this.temperatureChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績日平均気温(℃)',
          backgroundColor: '#446D62',
          borderColor: '#446D62',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('temperature'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('temperature')),
          data: this.createdActualResultsData('temperature'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較日平均気温(℃)',
          backgroundColor: '#8AA29C',
          borderColor: '#8AA29C',
          hidden: this.getShowPropriety('temperature'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績最高気温(℃)',
          backgroundColor: '#E9516B',
          borderColor: '#E9516B',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('temperatureHighest'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('temperature_highest')),
          data: this.createdActualResultsData('temperature_highest'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較最高気温(℃)',
          backgroundColor: '#ED92A4',
          borderColor: '#ED92A4',
          hidden: this.getShowPropriety('temperatureHighest'),
          spanGaps: false,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績最低気温(℃)',
          backgroundColor: 'rgba(143, 143, 143, 0.3)',
          borderColor: '#51B4E9',
          fill: '-2',
          spanGaps: true,
          hidden: this.getShowPropriety('temperatureLowest'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('temperature_lowest')),
          data: this.createdActualResultsData('temperature_lowest'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較最低気温(℃)',
          backgroundColor: 'rgba(143, 143, 143, 0.2)',
          borderColor: '#c1dfef',
          hidden: this.getShowPropriety('temperatureLowest'),
          spanGaps: true,
          fill: '-2',
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績寒暖差(℃)',
          backgroundColor: '#9D0538',
          borderColor: '#9D0538',
          hidden: true
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較寒暖差(℃)',
          backgroundColor: '#BF6483',
          borderColor: '#BF6483',
          hidden: true
        }
      ]
    }
  }

  public createTemperatureDifferenceChart () {
    this.temperatureDifferenceChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績寒暖差(℃)',
          backgroundColor: '#9D0538',
          borderColor: '#9D0538',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('temperatureDifference'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('temperature_difference')),
          data: this.createdActualResultsData('temperature_difference'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較寒暖差(℃)',
          backgroundColor: '#BF6483',
          borderColor: '#BF6483',
          hidden: this.getShowPropriety('temperatureDifference'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        }
      ]
    }
  }

  public createWeedGrowthChart () {
    this.weedGrowthChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '経過予測雑草丈(cm)',
          backgroundColor: '#13A10A',
          borderColor: '#13A10A',
          fill: false,
          spanGaps: true,
          hidden: false,
          pointRadius: this.judgePointRadius(this.createWeedGrowth()),
          data: this.createWeedGrowth(),
          datalabels: {
            display: false
          }
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '初期予測雑草丈(cm)',
          backgroundColor: 'rgba(15, 173, 4, 0.3)',
          borderColor: 'rgba(15, 173, 4, 0.3)',
          hidden: false,
          spanGaps: true,
          fill: true,
          pointRadius: 0,
          data: this.createPreWeedGrowth(),
          datalabels: {
            display: false
          }
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '警報値',
          backgroundColor: '#707070',
          borderColor: '#707070',
          borderWidth: 1,
          fill: false,
          spanGaps: true,
          pointRadius: 0,
          lineTension: 0,
          borderDash: [5, 5],
          hidden: false,
          data: this.createWeedAlarmValue(),
          datalabels: {
            display: false
          }
        }
      ]
    }
  }

  public active () {
    this.isActive = !this.isActive
  }

  /* 今日のポイントのみ色を変える(実測) */
  public performancePointBgColor () {
    let points = this.createdActualResultsData('integration_temperature')
    let todayColor = '#ff0000'
    let defaultColor = '#0f6594'

    // すべてdefaultColorの配列を作る
    let bgColors = new Array(Object.keys(points).length)
    bgColors.fill(defaultColor)

    // 最終日のみ赤を入れる
    if (points.length !== 0) {
      // null以外で配列を作成
      const array = points.filter((val) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = points.lastIndexOf(lastDayVal)

      bgColors[key] = todayColor
    }

    return bgColors
  }

  private judgePointRadius (data: any[]) {
    let countNotNull: number = 0
    for (let i in data) {
      if (data[i] !== null) {
        countNotNull++
      }
    }

    // null以外に値が1件ならポイントを表示、それ以外はポイントを表示しない
    if (countNotNull === 1) {
      return 3
    } else {
      return 0
    }
  }

  /* 今日のポイントのみ色を変える(予測) */
  public predictionPointBgColor () {
    let points = this.createPredictionTemperature()
    let plantingData = this.createdActualResultsData('integration_temperature')
    let graphData = JSON.parse(Session.getGraphData()!)
    let lastDay: any = Object.keys(graphData).pop()
    let todayColor = '#ff0000'
    let defaultColor = '#0f6594'

    // すべてdefaultColorの配列を作る
    var bgColors = new Array(Object.keys(graphData).length)
    bgColors.fill(defaultColor)

    // 最終日のみ赤を入れる
    if (points.length !== 0) {
      // null以外で配列を作成
      const array = plantingData.filter((val) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = plantingData.lastIndexOf(lastDayVal)

      bgColors[key] = todayColor
    }

    return bgColors
  }

  /* 今日のポイントのみ色を変える(予測) */
  public integratedInsolationPointBgColor () {
    let points = this.createdGoalData('goal_integrated_insolation')
    let plantingData = this.createdActualResultsData('integrated_insolation')
    let graphData = JSON.parse(Session.getGraphData()!)
    let lastDay: any = Object.keys(graphData).pop()
    let todayColor = '#ff0000'
    let defaultColor = '#FFCE48'

    // すべてdefaultColorの配列を作る
    var bgColors = new Array(Object.keys(graphData).length)
    bgColors.fill(defaultColor)

    // 最終日のみ赤を入れる
    if (points.length !== 0) {
      // null以外で配列を作成
      const array = plantingData.filter((val) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = plantingData.lastIndexOf(lastDayVal)

      bgColors[key] = todayColor
    }

    return bgColors
  }

  /* chartのラベルを作成 */
  public getLabels () {
    const labels: any[] = []
    const graphData = JSON.parse(Session.getGraphData()!)
    const graphLastDay = parseInt(Object.keys(graphData).pop()!)
    const harvestDate = parseInt(Session.getHarvestDate()!)
    const masterData = JSON.parse(Session.getMasterData()!)
    const maxHarvestTime = parseInt(JSON.parse(Session.getHarvestTime()!))

    let masterLastDay: any = 0
    if (masterData !== null) {
      masterLastDay = parseInt(Object.keys(masterData).pop()!)
    }

    // 始まりを播種日-10日にする
    const plantingDay = String(JSON.parse(Session.getPlantingDay()!))

    if (plantingDay === null) {
      return []
    }
    const minDay = DateClass.formingDate(plantingDay)
    minDay.setDate(minDay.getDate() - 10)

    // 全て数値に変換
    const status = parseInt(Session.getHarvestStatus()!)
    const harvestStatusDay = Session.getHarvestStatusDay()!
    const updateDate = new Date(harvestStatusDay)
    const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + DateClass.toDoubleDigits(updateDate.getDate())
    const statusChangeDate = parseInt(formingDate)
    let maxDay: any

    if (status === harvestStatus.CHANCEL || status === harvestStatus.HARVESTE_INSTRUCTIONS) {
      let day: any
      /*
      * ①収穫適期の最終
      * ②マスターデータの収穫適期
      * ③実測データの最終日
      * どれが一番大きいか
      */
      if (isNaN(masterLastDay) && isNaN(graphLastDay) && isNaN(maxHarvestTime)) {
        // 全てのデータがない場合
        this.$emit('show-alert')
        return
      } else if (isNaN(masterLastDay) && isNaN(graphLastDay)) {
        // マスターデータと実測データがない
        day = maxHarvestTime
      } else if (isNaN(masterLastDay) && isNaN(maxHarvestTime)) {
        // マスターデータと収穫適期の最終日がない
        day = graphLastDay
      } else if (isNaN(graphLastDay) && isNaN(maxHarvestTime)) {
        // 実測データと収穫適期の最終日がない
        day = masterLastDay
      } else if (isNaN(masterLastDay)) {
        // マスターデータがない
        day = this.judgeMaxDay(graphLastDay, maxHarvestTime)
      } else if (isNaN(graphLastDay)) {
        // 実測データがない
        day = this.judgeMaxDay(masterLastDay, maxHarvestTime)
      } else if (isNaN(maxHarvestTime)) {
        // 収穫適期の最終日がない
        day = this.judgeMaxDay(graphLastDay, masterLastDay)
      } else {
        // 3つすべて存在する場合
        if (masterLastDay >= graphLastDay && masterLastDay >= maxHarvestTime) {
          day = masterLastDay
        } else if (graphLastDay >= masterLastDay && graphLastDay >= maxHarvestTime) {
          day = graphLastDay
        } else if (maxHarvestTime >= masterLastDay && maxHarvestTime >= graphLastDay) {
          day = maxHarvestTime
        }
      }
      // ステータス変更日が①②③より大きいか判定
      if (statusChangeDate > day) {
        maxDay = day
      } else {
        if (day === graphLastDay && statusChangeDate > masterLastDay && statusChangeDate > maxHarvestTime) {
          maxDay = statusChangeDate
        } else {
          maxDay = harvestDate
        }
      }
    } else {
      maxDay = harvestDate
    }

    // 最大日を+30日にする
    this.graphMaxDay = DateClass.formingDate(maxDay)
    this.graphMaxDay.setDate(this.graphMaxDay.getDate() + 30)
    this.$store.commit('fieldDetailsState/setMaxDate', this.graphMaxDay)

    for (var i = minDay; i < this.graphMaxDay; i = new Date(i.setDate(i.getDate() + 1))) {
      labels.push(i)
    }
    this.label = labels
    return labels
  }

  /* グラフ描画領域の最大値を判定 */
  public judgeMaxDay (a: number, b: number) : any {
    let maxDay: any

    if (a >= b) {
      maxDay = a
    } else {
      maxDay = b
    }

    return maxDay
  }

  // 予測積算温度
  public createPredictionTemperature () {
    let plantingData = this.createdActualResultsData('integration_temperature')
    let predictionData = JSON.parse(Session.getPredictionData()!)
    let array: any[] = []
    let filterArray: any[][] = []
    const predictionTemp: any[] = []

    // 実測データの最終日を取得
    let graphData = JSON.parse(Session.getGraphData()!)
    let lastDay: any = Object.keys(graphData).pop()
    let date: any = DateClass.formingDate(lastDay)

    // 目標データがない場合は空を返す
    if (predictionData === null) {
      return []
    }

    for (var i in predictionData) {
      array = []

      for (var j = 0; j < this.label.length; j++) {
        let day = DateClass.formingDate(i)

        if (this.label[j] < date) {
          array.push(null)
        } else {
          if (this.label[j].getTime() === day.getTime()) {
            array.push(predictionData[i].integration_temperature)
          } else {
            array.push(null)
          }
        }
      }
      filterArray.push(array)
    }

    let graphDataLength = Object.keys(predictionData).length
    for (var k = 0; k < filterArray[0].length; k++) {
      let data: number = 0
      for (var l = 0; l < graphDataLength; l++) {
        if (filterArray[l][k] === null) {
          filterArray[l][k] = 0
        }
        data += filterArray[l][k]
      }

      if (data !== 0) {
        predictionTemp.push(data)
      } else {
        predictionTemp.push(null)
      }
    }

    // 予測線の始まりは実績の最終日
    if (plantingData.length !== 0) {
      // null以外で配列を作成
      const array = plantingData.filter((val) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = plantingData.lastIndexOf(lastDayVal)

      predictionTemp[key] = plantingData[key]
    }

    return predictionTemp
  }

  // 経過予測雑草丈
  public createWeedGrowth () {
    const weedGrowth = []
    let weedContents: any = []
    let data = JSON.parse(Session.getWeedGrowthData()!)

    if (data === null) {
      return []
    }

    // 1つのオブジェクト配列に整形
    for (let i in data.weed_growths) {
      if (i === '0') {
        weedContents = data.weed_growths[0].weed_contents
      } else {
        weedContents = weedContents.concat(data.weed_growths[i].weed_contents)
      }
    }

    for (var j in this.label) {
      let date = new Date(this.label[j]).getTime()
      const dateData = weedContents.filter((data: any) => new Date(data.weed_date + 'T00:00:00').getTime() === date)

      if (dateData.length === 0) {
        weedGrowth.push(null)
      } else {
        weedGrowth.push(dateData[0].weed_height)
      }
    }
    return weedGrowth
  }

  // 初期予測雑草丈
  public createPreWeedGrowth () {
    const weedGrowth = []
    let weedContents: any = []
    let data = JSON.parse(Session.getWeedGrowthData()!)

    if (data === null) {
      return []
    }

    // 1つのオブジェクト配列に整形
    for (let i in data.pre_weed_growths) {
      if (i === '0') {
        weedContents = data.pre_weed_growths[0].weed_contents
      } else {
        weedContents = weedContents.concat(data.pre_weed_growths[i].weed_contents)
      }
    }

    for (var j in this.label) {
      let date = new Date(this.label[j]).getTime()
      const dateData = weedContents.filter((data: any) => new Date(data.weed_date + 'T00:00:00').getTime() === date)

      if (dateData.length === 0) {
        weedGrowth.push(null)
      } else {
        weedGrowth.push(dateData[0].weed_height)
      }
    }
    return weedGrowth
  }

  // 警報値
  public createWeedAlarmValue () {
    const weedGrowth: any = []
    let data = JSON.parse(Session.getWeedGrowthData()!)
    if (data === null) {
      return []
    }

    let weedContents = data.alarm_value

    for (var j in this.label) {
      let date = new Date(this.label[j]).getTime()
      const dateData = weedContents.filter((data: any) => new Date(data.alarm_date + 'T00:00:00').getTime() === date)

      if (dateData.length === 0) {
        if (j === '0') {
          weedGrowth.push(null)
        } else {
          weedGrowth.push(weedGrowth[parseInt(j) - 1])
        }
      } else {
        weedGrowth.push(dateData[0].weed_height_threshold)
      }
    }
    return weedGrowth
  }

  /* 比較データの作成 */
  public createComparisonData () {
    if (this.$store.state.graphToggleState.hiddenComparisonData) {
      return
    }
    let comparisonData = JSON.parse(Session.getComparisonData()!)
    /* メイングラフ */
    const comparisonIntegrationTemperature: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonElement1: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonElement2: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonElement3: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonElement4: any[] = [null, null, null, null, null, null, null, null, null]
    /* 複合グラフ */
    const comparisonWaterContainRate: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonGroundTemp: any[] = [null, null, null, null, null, null, null, null, null]
    /* 積算降水量 */
    const comparisonIntegratedPrecipitation: any[] = [null, null, null, null, null, null, null, null, null]
    /* 積算日射量 */
    const comparisonIntegratedInsolation: any[] = [null, null, null, null, null, null, null, null, null]
    /* 気温 */
    const comparisonTemperature: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonTemperatureHighest: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonTemperatureLowest: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonTemperatureDifference: any[] = [null, null, null, null, null, null, null, null, null]
    /* 日射量 */
    const comparisonSolarRadation: any[] = [null, null, null, null, null, null, null, null, null]

    let count = 9
    for (var i in comparisonData) {
      ++count
      /* this.label.length(実績データのX軸数)の値に一致するまで、比較グラフデータ生成を行う */
      if (count > this.label.length) {
        break
      }
      /* メイングラフ */
      comparisonIntegrationTemperature.push(comparisonData[i].integration_temperature)
      comparisonElement1.push(comparisonData[i].element1)
      comparisonElement2.push(comparisonData[i].element2)
      comparisonElement3.push(comparisonData[i].element3)
      comparisonElement4.push(comparisonData[i].element4)
      /* 複合グラフ */
      comparisonWaterContainRate.push(comparisonData[i].water_contain_rate)
      comparisonGroundTemp.push(comparisonData[i].ground_temp)
      /* 積算降水量 */
      comparisonIntegratedPrecipitation.push(comparisonData[i].integrated_precipitation_amount)
      /* 積算日射量 */
      comparisonIntegratedInsolation.push(comparisonData[i].integrated_insolation)
      /* 気温 */
      comparisonTemperature.push(comparisonData[i].temperature)
      comparisonTemperatureHighest.push(comparisonData[i].temperature_highest)
      comparisonTemperatureLowest.push(comparisonData[i].temperature_lowest)
      comparisonTemperatureDifference.push(comparisonData[i].temperature_difference)
      /* 日射量 */
      comparisonSolarRadation.push(comparisonData[i].solar_radation)
    }

    /* データの書き換え */
    // メイングラフ
    this.chartData.datasets[1].data = comparisonIntegrationTemperature
    this.chartData.datasets[5].data = comparisonElement1
    this.chartData.datasets[8].data = comparisonElement2
    this.chartData.datasets[11].data = comparisonElement3
    this.chartData.datasets[14].data = comparisonElement4

    // 複合グラフ
    this.areaChartData.datasets[1].data = comparisonWaterContainRate
    this.areaChartData.datasets[1].pointRadius = this.judgePointRadius(comparisonWaterContainRate)
    this.areaChartData.datasets[4].data = comparisonGroundTemp
    this.areaChartData.datasets[4].pointRadius = this.judgePointRadius(comparisonGroundTemp)

    // 積算降水量
    this.predictionChartData.datasets[1].data = comparisonIntegratedPrecipitation
    this.predictionChartData.datasets[1].pointRadius = this.judgePointRadius(comparisonIntegratedPrecipitation)

    // 日射量
    this.solarRadationChartData.datasets[1].data = comparisonSolarRadation
    this.solarRadationChartData.datasets[1].pointRadius = this.judgePointRadius(comparisonSolarRadation)
    // 積算日射量
    this.solarRadationChartData.datasets[4].data = comparisonIntegratedInsolation
    this.solarRadationChartData.datasets[4].pointRadius = this.judgePointRadius(comparisonIntegratedInsolation)
    // 気温
    this.temperatureChartData.datasets[1].data = comparisonTemperature
    this.temperatureChartData.datasets[3].data = comparisonTemperatureHighest
    this.temperatureChartData.datasets[5].data = comparisonTemperatureLowest
    this.temperatureDifferenceChartData.datasets[1].data = comparisonTemperatureDifference

    // 比例ダイアログの表示
    this.$store.commit('graphToggleState/setShowComparison', true)
    this.$store.commit('graphToggleState/setChangeComparisonGraph', false)
  }

  /* 比較データ */
  public changeComparisonGraph () {
    // 比較なしの場合は凡例をdisableに戻す
    if (this.$store.state.graphToggleState.hiddenComparisonData) {
      let legend1: any = document.getElementById('legend-1')
      let child: any = legend1.getElementsByTagName('li')
      child[1].classList.add('disabled')
      child[5].classList.add('disabled')
      child[8].classList.add('disabled')
      child[11].classList.add('disabled')
      child[14].classList.add('disabled')

      let legend2: any = document.getElementById('legend-2')
      let areaChild: any = legend2.getElementsByTagName('li')
      areaChild[1].classList.add('disabled')
      areaChild[4].classList.add('disabled')

      let legend3: any = document.getElementById('legend-3')
      let predictionChild: any = legend3.getElementsByTagName('li')
      predictionChild[1].classList.add('disabled')

      let legend4: any = document.getElementById('legend-4')
      let solarRadationChild: any = legend4.getElementsByTagName('li')
      solarRadationChild[1].classList.add('disabled')
      solarRadationChild[4].classList.add('disabled')

      let legend6: any = document.getElementById('legend-6')
      let temperatureChild: any = legend6.getElementsByTagName('li')
      temperatureChild[1].classList.add('disabled')
      temperatureChild[3].classList.add('disabled')
      temperatureChild[5].classList.add('disabled')
      temperatureChild[7].classList.add('disabled')
    }

    this.updateAllGraph()
  }

  // 再レンダリング
  private updateAllGraph () {
    let graph: any = this.$refs.graph
    if (graph !== undefined) {
      graph.updateGraph()
    }

    let areaGraph: any = this.$refs.areaGraph
    if (areaGraph !== undefined) {
      areaGraph.updateGraph(this.areaChartOptions)
    }

    let predictionGraph: any = this.$refs.predictionGraph
    if (predictionGraph !== undefined) {
      predictionGraph.updateGraph(this.precipitationChartOptions)
    }

    let solarRadationGraph: any = this.$refs.solarRadationGraph
    if (solarRadationGraph !== undefined) {
      solarRadationGraph.updateGraph(this.solarRadationChartOptions)
    }

    let temperatureGraph: any = this.$refs.temperatureGraph
    if (temperatureGraph !== undefined) {
      temperatureGraph.updateGraph(this.temperatureChartOptions)
    }

    let temperatureDifferenceGraph: any = this.$refs.temperatureDifferenceGraph
    if (temperatureDifferenceGraph !== undefined) {
      temperatureDifferenceGraph.updateGraph(this.temperatureDifferenceChartOptions)
    }

    let weedGrowthGraph: any = this.$refs.weedGrowthGraph
    if (weedGrowthGraph !== undefined) {
      weedGrowthGraph.updateGraph(this.weedGrowthChartOptions)
    }
    this.isInit = false
    this.$emit('is-updated')
  }

  /* 収穫適期の最短取得 */
  public getMinHarvestTime () {
    let harvestDate: Date
    if (JSON.parse(Session.getHarvestDetaisls()!).harvest_min_date) {
      let min = JSON.parse(Session.getHarvestDetaisls()!).harvest_min_date
      harvestDate = DateClass.formingDate(Session.getHarvestTime()!)
      harvestDate.setDate(harvestDate.getDate() - min)
    } else {
      harvestDate = DateClass.formingDate(Session.getHarvestTime()!)
      harvestDate.setDate(harvestDate.getDate() - 3)
    }
    return harvestDate
  }

  /* 収穫適期の最終取得 */
  public getMaxHarvestTime () {
    let harvestDate: Date
    if (JSON.parse(Session.getHarvestDetaisls()!).harvest_max_date) {
      let max = JSON.parse(Session.getHarvestDetaisls()!).harvest_max_date
      harvestDate = DateClass.formingDate(Session.getHarvestTime()!)
      harvestDate.setDate(harvestDate.getDate() + max)
    } else {
      harvestDate = DateClass.formingDate(Session.getHarvestTime()!)
      harvestDate.setDate(harvestDate.getDate() + 3)
    }
    return harvestDate
  }

  /* ステージバーの日付 */
  public createStageBar (growthStageList: any[]) {
    const growthDateList: any[] = []

    // ステージデータがない場合はステージバーを作らない
    if (growthStageList === null || (growthStageList.length === 1 && growthStageList[0].id === 0)) {
      return
    }
    for (var i in growthStageList) {
      let plantingDay = DateClass.formingDate(Session.getPlantingDay()!)
      plantingDay.setDate(plantingDay.getDate() + growthStageList[i].elapsed_days)

      growthDateList.push(plantingDay)
    }

    for (var j = 0; j < growthDateList.length; j++) {
      let stageLine = {}
      let harvestTime = {}
      let stageLabel = {}
      let dateLabel = {}

      /* 線のみ描画 */
      if (j !== 4) {
        stageLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'barLine/' + growthStageList[j].growth_step,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: '#D1D1D1',
          borderWidth: 2
        }
        this.chartOptions.annotation.annotations.push(stageLine)
      } else {
        stageLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'barLine/' + growthStageList[j].growth_step,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: '#D1D1D1',
          borderWidth: 2
        }
        this.chartOptions.annotation.annotations.push(stageLine)
      }

      /* ラベルのみ描画 */
      if (j % 2 === 0) {
        stageLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'bar/' + growthStageList[j].growth_step,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: this.transparentColor,
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontSize: 11,
            fontColor: '#333',
            content: growthStageList[j].growth_stage_name,
            fontStyle: 'bold',
            enabled: true,
            xPadding: 13,
            yPadding: 8,
            yAdjust: 8,
            position: 'top'
          },
          onMouseover: function (event: any) {
            CommonClass.setGrowthData(this, event)
          },
          onMouseleave: this.closeGraphDialog,
          onClick: this.changeStageDate
        }
        dateLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'label/' + growthStageList[j].growth_step,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: this.transparentColor,
          borderWidth: 2,
          label: {
            backgroundColor: this.showStageDate ? this.changeStageBg(growthStageList[j].growth_stage_histories) : this.transparentColor,
            fontSize: 11,
            fontColor: this.showStageDate ? '#333' : this.transparentColor,
            content: this.createLabel(growthStageList[j]),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 8,
            yPadding: 7,
            yAdjust: 34,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog
        }
      } else {
        stageLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'bar/' + growthStageList[j].growth_step,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: this.transparentColor,
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontSize: 11,
            fontColor: '#333',
            content: growthStageList[j].growth_stage_name,
            fontStyle: 'bold',
            enabled: true,
            xPadding: 13,
            yPadding: 8,
            yAdjust: 60,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog,
          onClick: this.changeStageDate
        }
        dateLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'label/' + growthStageList[j].growth_step,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: this.transparentColor,
          borderWidth: 2,
          label: {
            backgroundColor: this.showStageDate ? this.changeStageBg(growthStageList[j].growth_stage_histories) : this.transparentColor,
            fontSize: 11,
            fontColor: this.showStageDate ? '#333' : this.transparentColor,
            content: this.createLabel(growthStageList[j]),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 8,
            yPadding: 7,
            yAdjust: 86,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog
        }
      }

      this.chartOptions.annotation.annotations.push(stageLabel)
      this.chartOptions.annotation.annotations.push(dateLabel)
    }

    // 収穫適期範囲
    let harvestTime = {
      drawTime: 'beforeDatasetsDraw',
      type: 'box',
      xScaleID: 'x-axis-0',
      yScaleID: 'yAxis_default_2',
      xMin: this.getMinHarvestTime(), // 変数で取得
      xMax: this.getMaxHarvestTime(), // 変数で取得
      yMin: 0,
      yMax: this.elementYMax,
      backgroundColor: 'rgba(193,193,193, .2)',
      borderColor: 'rgba(193,193,193, .2)'
    }
    this.chartOptions.annotation.annotations.push(harvestTime)
  }

  /* ステージバーの日付 */
  public createWeedCompletedBar () {
    this.weedGrowthData = JSON.parse(Session.getWeedGrowthData()!)
    if (this.weedGrowthData === null) {
      return
    }
    /* 線のみ描画 */
    const date = this.label[this.label.length - 1]
    for (let j in this.weedGrowthData.weed_growths) {
      if (this.weedGrowthData.weed_growths[j].weeding_completed !== null &&
          new Date(this.weedGrowthData.weed_growths[j].weeding_completed.weeding_completed_date).getTime() <= new Date(date).getTime()) {
        let completedLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: new Date(this.weedGrowthData.weed_growths[j].weeding_completed.weeding_completed_date),
          borderColor: '#D1D1D1',
          borderWidth: 2
        }
        this.weedGrowthChartOptions.annotation.annotations.push(completedLine)
      }
    }

    if (this.weedGrowthData.weeding_warning !== null) {
      let warningLine = {
        drawTime: 'beforeDatasetsDraw',
        type: 'line',
        mode: 'vertical',
        scaleID: 'x-axis-0',
        value: new Date(this.weedGrowthData.weeding_warning.weeding_warning_date),
        borderColor: '#D1D1D1',
        borderWidth: 2
      }
      this.weedGrowthChartOptions.annotation.annotations.push(warningLine)
    }
  }

  private changeStageBg (val: any[]) {
    if (val === undefined || val.length === 0) {
      return 'rgba(193,193,193,0.5)'
    } else {
      return 'rgba(247,215,30,0.7)'
    }
  }

  private createLabel (data: any) {
    if (Session.getPlantingDay()! === null) {
      return
    }
    let content: string
    let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (data.elapsed_days * 24 * 60 * 60 * 1000))

    content = DateClass.toDoubleDigits(newDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(newDate.getDate())
    return content
  }

  /* ステージバーをクリックしたときの処理 */
  public changeStageDate (event: any) {
    this.showDetailsDialog = false
    let growthData = Vue.prototype.$globalGrowthData
    let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (growthData.elapsed_days * 24 * 60 * 60 * 1000))
    let date = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
    let today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    // 播種日と今日より先は変更不可
    if (growthData.growth_step !== 1 && date <= today) {
      this.$store.commit('stageUpdateState/setChangeId', parseInt(growthData.growth_stage_id))
      this.showStageUpdateModal = true
    }
  }

  public closeStageUpdateModal () {
    this.showStageUpdateModal = false
  }

  /* ステージバーの更新処理 */
  private reacquireStage () {
    this.$emit('reacquire-stage-data')
  }

  private showErrorAlert (msg: string) {
    this.$emit('show-error-alert', msg)
  }

  private showError409Modal () {
    this.$emit('show-error409-modal')
  }

  /* スライドバー移動処理 */
  public changeDate (e: any) {
    let date = this.label[this.slide]
    let keyDate = '' + date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate())

    /* state管理 */
    this.$store.commit('dateChoiceState/setChangeDate', keyDate)
  }

  public overWriteDate (e: any) {
    let date = e.subject.config.value._d
    let keyDate = '' + date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate())
    /* state管理 */
    this.$store.commit('dateChoiceState/setChangeDate', keyDate)
  }

  /* グラフのダイアログを表示 */
  public showGraphDialog () {
    if (!this.showDetailsDialog) {
      this.growthData = Vue.prototype.$globalGrowthData
      this.stageDate = Vue.prototype.$globalStageDate
      this.$store.commit('setFlagState/setGraphDialogFlag', true)
      let growthStageList = JSON.parse(Session.getGrowthStage()!)

      // ポジション
      this.dialogLeft = (Vue.prototype.$globalElX - 50) + 'px'

      for (let i in growthStageList) {
        if (growthStageList[i].growth_step === this.growthData.growth_step) {
          let num = parseInt(i) % 2
          if (num === 0) {
            this.dialogTop = '105px'
          } else {
            this.dialogTop = '155px'
          }
          break
        }
      }

      this.toggleDialog()
    } else {
      this.toggleDialog()
    }
  }

  public toggleDialog () {
    if (this.showDetailsDialog) {
      this.showDetailsDialog = false
    } else {
      this.showDetailsDialog = true
    }
  }

  public closeGraphDialog ($event: any) {
    $event.preventDefault()
    this.showDetailsDialog = false
  }

  private getCheckBoxs () {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (settingData === null || settingData === undefined) {
      this.checkboxData = []
    } else {
      let data = settingData.checkboxs
      for (let i in settingData.checkboxs2) {
        data.push(settingData.checkboxs2[i])
      }
      for (let i in settingData.checkboxs3) {
        data.push(settingData.checkboxs3[i])
      }
      for (let i in settingData.checkboxs4) {
        data.push(settingData.checkboxs4[i])
      }
      for (let i in settingData.checkboxs5) {
        data.push(settingData.checkboxs5[i])
      }
      for (let i in settingData.checkboxs6) {
        data.push(settingData.checkboxs6[i])
      }
      this.checkboxData = data
    }
  }

  /* グラフ表示切り替え */
  public displayGraph () {
    this.createComparisonData()
    let legend1: any = document.getElementById('legend-1')
    let child: any = legend1.getElementsByTagName('li')

    let legend2: any = document.getElementById('legend-2')
    let child2: any = legend2.getElementsByTagName('li')

    let legend3: any = document.getElementById('legend-3')
    let child3: any = legend3.getElementsByTagName('li')

    let legend4: any = document.getElementById('legend-4')
    let child4: any = legend4.getElementsByTagName('li')

    let legend5: any = document.getElementById('legend-5')
    let child5: any = legend5.getElementsByTagName('li')

    let legend6: any = document.getElementById('legend-6')
    let child6: any = legend6.getElementsByTagName('li')

    // グラフの凡例ができているか確認
    if (child.length === 0 || child2.length === 0 || child3.length === 0 || child4.length === 0 || child5.length === 0 || child6.length === 0) {
      setTimeout(this.displayGraph, 200)
      return
    }

    this.getCheckBoxs()
    let data

    if (this.checkboxData.length === 0) {
      data = [
        { label: '積算温度', value: 'integrationTemperature', checked: true, display: true },
        { label: process.env.VUE_APP_ELEMENT1_NAME, value: 'element1', checked: true, display: true },
        { label: process.env.VUE_APP_ELEMENT2_NAME, value: 'element2', checked: true, display: true },
        { label: process.env.VUE_APP_ELEMENT3_NAME, value: 'element3', checked: true, display: true },
        { label: process.env.VUE_APP_ELEMENT4_NAME, value: 'element4', checked: true, display: true },
        { label: '日平均気温', value: 'temperature', checked: false, display: true },
        { label: '最高気温', value: 'temperatureHighest', checked: false, display: true },
        { label: '最低気温', value: 'temperatureLowest', checked: false, display: true },
        { label: '寒暖差', value: 'temperatureDifference', checked: false, display: true },
        { label: '積算降水量', value: 'soilStatus', checked: false, display: true },
        { label: '日射量', value: 'solarRadation', checked: false, display: true },
        { label: '積算日射量', value: 'integratedInsolation', checked: false, display: true },
        { label: '雑草丈', value: 'weedGrowth', checked: false, display: true },
        { label: '体積含水率', value: 'waterContainRate', checked: true, display: true },
        { label: '地温', value: 'groundTemp', checked: false, display: true }
      ]
    } else {
      data = this.checkboxData
    }

    for (var i in data) {
      if (data[i].label === '積算温度') {
        if (!data[i].checked) {
          this.chartData.datasets[0].hidden = true
          this.chartData.datasets[1].hidden = true
          this.chartData.datasets[2].hidden = true
          this.chartData.datasets[3].hidden = true
          // 凡例書き換え
          child[0].classList.add('hidden')
          child[1].classList.add('hidden')
          child[2].classList.add('hidden')
          child[3].classList.add('hidden')
        } else {
          this.chartData.datasets[0].hidden = false
          this.chartData.datasets[1].hidden = false
          this.chartData.datasets[2].hidden = false
          this.chartData.datasets[3].hidden = false
          // 凡例書き換え
          child[0].classList.remove('hidden')
          child[1].classList.remove('hidden')
          child[2].classList.remove('hidden')
          child[3].classList.remove('hidden')
        }
      }

      if (data[i].label === process.env.VUE_APP_ELEMENT1_NAME) {
        if (!data[i].checked) {
          this.chartData.datasets[13].hidden = true
          this.chartData.datasets[14].hidden = true
          this.chartData.datasets[15].hidden = true
          // 凡例書き換え
          child[13].classList.add('hidden')
          child[14].classList.add('hidden')
          child[15].classList.add('hidden')
        } else {
          this.chartData.datasets[13].hidden = false
          this.chartData.datasets[14].hidden = false
          this.chartData.datasets[15].hidden = false
          // 凡例書き換え
          child[13].classList.remove('hidden')
          child[14].classList.remove('hidden')
          child[15].classList.remove('hidden')
        }
      }

      if (data[i].label === process.env.VUE_APP_ELEMENT2_NAME) {
        if (!data[i].checked) {
          this.chartData.datasets[4].hidden = true
          this.chartData.datasets[5].hidden = true
          this.chartData.datasets[6].hidden = true
          // 凡例書き換え
          child[4].classList.add('hidden')
          child[5].classList.add('hidden')
          child[6].classList.add('hidden')
        } else {
          this.chartData.datasets[4].hidden = false
          this.chartData.datasets[5].hidden = false
          this.chartData.datasets[6].hidden = false
          // 凡例書き換え
          child[4].classList.remove('hidden')
          child[5].classList.remove('hidden')
          child[6].classList.remove('hidden')
        }
      }

      if (data[i].label === process.env.VUE_APP_ELEMENT3_NAME) {
        if (!data[i].checked) {
          this.chartData.datasets[7].hidden = true
          this.chartData.datasets[8].hidden = true
          this.chartData.datasets[9].hidden = true
          // 凡例書き換え
          child[7].classList.add('hidden')
          child[8].classList.add('hidden')
          child[9].classList.add('hidden')
        } else {
          this.chartData.datasets[7].hidden = false
          this.chartData.datasets[8].hidden = false
          this.chartData.datasets[9].hidden = false
          // 凡例書き換え
          child[7].classList.remove('hidden')
          child[8].classList.remove('hidden')
          child[9].classList.remove('hidden')
        }
      }

      if (data[i].label === process.env.VUE_APP_ELEMENT4_NAME) {
        if (!data[i].checked) {
          this.chartData.datasets[10].hidden = true
          this.chartData.datasets[11].hidden = true
          this.chartData.datasets[12].hidden = true
          // 凡例書き換え
          child[10].classList.add('hidden')
          child[11].classList.add('hidden')
          child[12].classList.add('hidden')
        } else {
          this.chartData.datasets[10].hidden = false
          this.chartData.datasets[11].hidden = false
          this.chartData.datasets[12].hidden = false
          // 凡例書き換え
          child[10].classList.remove('hidden')
          child[11].classList.remove('hidden')
          child[12].classList.remove('hidden')
        }
      }

      if (data[i].label === '体積含水率') {
        if (!data[i].checked) {
          this.areaChartData.datasets[0].hidden = true
          this.areaChartData.datasets[1].hidden = true
          this.areaChartData.datasets[2].hidden = true
          // 凡例書き換え
          child2[0].classList.add('hidden')
          child2[1].classList.add('hidden')
          child2[2].classList.add('hidden')
          this.showAreaChart = false
        } else {
          this.areaChartData.datasets[0].hidden = false
          this.areaChartData.datasets[1].hidden = false
          this.areaChartData.datasets[2].hidden = false
          // 凡例書き換え
          child2[0].classList.remove('hidden')
          child2[1].classList.remove('hidden')
          child2[2].classList.remove('hidden')
          this.showAreaChart = true
        }
      }

      if (data[i].label === '地温') {
        if (!data[i].checked) {
          this.areaChartData.datasets[3].hidden = true
          this.areaChartData.datasets[4].hidden = true
          this.areaChartData.datasets[5].hidden = true
          child2[3].classList.add('hidden')
          child2[4].classList.add('hidden')
          child2[5].classList.add('hidden')
        } else {
          this.areaChartData.datasets[3].hidden = false
          this.areaChartData.datasets[4].hidden = false
          this.areaChartData.datasets[5].hidden = false
          child2[3].classList.remove('hidden')
          child2[4].classList.remove('hidden')
          child2[5].classList.remove('hidden')
          this.showAreaChart = true
        }
      }

      if (data[i].label === '積算降水量') {
        if (!data[i].checked) {
          this.showTemparatureChart = false
        } else {
          this.showTemparatureChart = true
          this.predictionChartData.datasets[0].hidden = false
          this.predictionChartData.datasets[1].hidden = false
          this.predictionChartData.datasets[2].hidden = false
          child3[0].classList.remove('hidden')
          child3[1].classList.remove('hidden')
          child3[2].classList.remove('hidden')
        }
      }

      if (data[i].label === '日射量') {
        if (!data[i].checked) {
          this.solarRadationChartData.datasets[0].hidden = true
          this.solarRadationChartData.datasets[1].hidden = true
          this.solarRadationChartData.datasets[2].hidden = true
          child4[0].classList.add('hidden')
          child4[1].classList.add('hidden')
          child4[2].classList.add('hidden')
          this.showSolarRadationChart = false
        } else {
          this.solarRadationChartData.datasets[0].hidden = false
          this.solarRadationChartData.datasets[1].hidden = false
          this.solarRadationChartData.datasets[2].hidden = false
          child4[0].classList.remove('hidden')
          child4[1].classList.remove('hidden')
          child4[2].classList.remove('hidden')
          this.showSolarRadationChart = true
        }
      }

      if (data[i].label === '積算日射量') {
        if (!data[i].checked) {
          this.solarRadationChartData.datasets[3].hidden = true
          this.solarRadationChartData.datasets[4].hidden = true
          this.solarRadationChartData.datasets[5].hidden = true
          child4[3].classList.add('hidden')
          child4[4].classList.add('hidden')
          child4[5].classList.add('hidden')
        } else {
          this.solarRadationChartData.datasets[3].hidden = false
          this.solarRadationChartData.datasets[4].hidden = false
          this.solarRadationChartData.datasets[5].hidden = false
          child4[3].classList.remove('hidden')
          child4[4].classList.remove('hidden')
          child4[5].classList.remove('hidden')
          this.showSolarRadationChart = true
        }
      }

      if (data[i].label === '日平均気温') {
        if (!data[i].checked) {
          this.temperatureChartData.datasets[0].hidden = true
          this.temperatureChartData.datasets[1].hidden = true
          child6[0].classList.add('hidden')
          child6[1].classList.add('hidden')
          this.showTemperatureChart = false
        } else {
          this.temperatureChartData.datasets[0].hidden = false
          this.temperatureChartData.datasets[1].hidden = false
          child6[0].classList.remove('hidden')
          child6[1].classList.remove('hidden')
          this.showTemperatureChart = true
        }
      }

      if (data[i].label === '最高気温') {
        if (!data[i].checked) {
          this.temperatureChartData.datasets[2].hidden = true
          this.temperatureChartData.datasets[3].hidden = true
          child6[2].classList.add('hidden')
          child6[3].classList.add('hidden')
        } else {
          this.temperatureChartData.datasets[2].hidden = false
          this.temperatureChartData.datasets[3].hidden = false
          child6[2].classList.remove('hidden')
          child6[3].classList.remove('hidden')
          this.showTemperatureChart = true
        }
      }

      if (data[i].label === '最低気温') {
        if (!data[i].checked) {
          this.temperatureChartData.datasets[4].hidden = true
          this.temperatureChartData.datasets[5].hidden = true
          child6[4].classList.add('hidden')
          child6[5].classList.add('hidden')
        } else {
          this.temperatureChartData.datasets[4].hidden = false
          this.temperatureChartData.datasets[5].hidden = false
          child6[4].classList.remove('hidden')
          child6[5].classList.remove('hidden')
          this.showTemperatureChart = true
        }
      }

      if (data[i].label === '寒暖差') {
        if (!data[i].checked) {
          this.temperatureDifferenceChartData.datasets[0].hidden = true
          this.temperatureDifferenceChartData.datasets[1].hidden = true
          child6[6].classList.add('hidden')
          child6[7].classList.add('hidden')
        } else {
          this.temperatureDifferenceChartData.datasets[0].hidden = false
          this.temperatureDifferenceChartData.datasets[1].hidden = false
          child6[6].classList.remove('hidden')
          child6[7].classList.remove('hidden')
          this.showTemperatureChart = true
        }
      }

      if (data[i].label === '雑草丈') {
        if (!data[i].checked) {
          this.showWeedGrowthChart = false
        } else {
          this.showWeedGrowthChart = true
        }
      }
    }

    // 比較系
    if (!this.$store.state.graphToggleState.hiddenComparisonData) {
      child[1].classList.remove('disabled')
      child[5].classList.remove('disabled')
      child[8].classList.remove('disabled')
      child[11].classList.remove('disabled')
      child[14].classList.remove('disabled')
      child2[1].classList.remove('disabled')
      child2[4].classList.remove('disabled')
      child3[1].classList.remove('disabled')
      child4[1].classList.remove('disabled')
      child4[4].classList.remove('disabled')
      child6[1].classList.remove('disabled')
      child6[3].classList.remove('disabled')
      child6[5].classList.remove('disabled')
      child6[7].classList.remove('disabled')
    } else {
      child[1].classList.add('disabled')
      child[5].classList.add('disabled')
      child[8].classList.add('disabled')
      child[11].classList.add('disabled')
      child[14].classList.add('disabled')
      child2[1].classList.add('disabled')
      child2[4].classList.add('disabled')
      child3[1].classList.add('disabled')
      child4[1].classList.add('disabled')
      child4[4].classList.add('disabled')
      child6[1].classList.add('disabled')
      child6[3].classList.add('disabled')
      child6[5].classList.add('disabled')
      child6[7].classList.add('disabled')
      this.chartData.datasets[1].hidden = true
      this.chartData.datasets[5].hidden = true
      this.chartData.datasets[8].hidden = true
      this.chartData.datasets[11].hidden = true
      this.chartData.datasets[14].hidden = true
      this.areaChartData.datasets[1].hidden = true
      this.areaChartData.datasets[4].hidden = true
      this.predictionChartData.datasets[1].hidden = true
      this.solarRadationChartData.datasets[1].hidden = true
      this.solarRadationChartData.datasets[4].hidden = true
      this.temperatureChartData.datasets[1].hidden = true
      this.temperatureChartData.datasets[3].hidden = true
      this.temperatureChartData.datasets[5].hidden = true
      this.temperatureDifferenceChartData.datasets[1].hidden = true
    }
    this.setAreaScaleYPadding()
    this.setPredictionScaleYPadding()
    this.setSolarRadationScaleYPadding()
    this.setTemperatureScaleYPadding()
    this.setTemperatureDifferenceScaleYPadding()
    this.updateAllGraph()
  }

  public displayLegend () {
    let myLegend: any = document.getElementById('legend-1')
    let legendItems: any = myLegend.getElementsByTagName('li')
    for (var i = 0; i < legendItems.length; i += 1) {
      legendItems[i].addEventListener('click', this.legendClickEvents, false)
    }
  }

  public displayAreaLegend () {
    let myLegend2: any = document.getElementById('legend-2')
    let legendItems2: any = myLegend2.getElementsByTagName('li')

    for (var j = 0; j < legendItems2.length; j += 1) {
      legendItems2[j].addEventListener('click', this.areaLegendClickEvents, false)
    }
  }

  public displayTemparatureLegend () {
    let myLegend2: any = document.getElementById('legend-3')
    let legendItems2: any = myLegend2.getElementsByTagName('li')

    for (var j = 0; j < legendItems2.length; j += 1) {
      legendItems2[j].addEventListener('click', this.predictionClickEvents, false)
    }
  }

  public displaySolarRadationLegend () {
    let myLegend4: any = document.getElementById('legend-4')
    let legendItems4: any = myLegend4.getElementsByTagName('li')

    for (var j = 0; j < legendItems4.length; j += 1) {
      legendItems4[j].addEventListener('click', this.solarRadationClickEvents, false)
    }
  }

  public displayWeedGrowthLegend () {
    let myLegend5: any = document.getElementById('legend-5')
    let legendItems5: any = myLegend5.getElementsByTagName('li')

    for (var j = 0; j < legendItems5.length; j += 1) {
      legendItems5[j].addEventListener('click', this.weedGrowthClickEvents, false)
    }
  }

  public displayTemperatureLegend () {
    let myLegend6: any = document.getElementById('legend-6')
    let legendItems6: any = myLegend6.getElementsByTagName('li')

    for (var j = 0; j < legendItems6.length; j += 1) {
      legendItems6[j].addEventListener('click', this.temperatureClickEvents, false)
    }
  }

  public legendClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    let parent = target.parentElement
    let child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.chartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.chartData.datasets[index].hidden === null || this.chartData.datasets[index].hidden === false) {
      this.chartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.chartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    let graph: any = this.$refs.graph
    if (graph !== undefined) {
      graph.updateGraph()
    }
  }

  public areaLegendClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    let parent = target.parentElement
    let child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.areaChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.areaChartData.datasets[index].hidden === null || this.areaChartData.datasets[index].hidden === false) {
      this.areaChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.areaChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    this.setAreaScaleYPadding()
    let areaGraph: any = this.$refs.areaGraph
    if (areaGraph !== undefined) {
      areaGraph.updateGraph(this.areaChartOptions)
    }
  }

  public predictionClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    let parent = target.parentElement
    let child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.predictionChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.predictionChartData.datasets[index].hidden === null || this.predictionChartData.datasets[index].hidden === false) {
      this.predictionChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.predictionChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    this.setPredictionScaleYPadding()
    let predictionGraph: any = this.$refs.predictionGraph
    if (predictionGraph !== undefined) {
      predictionGraph.updateGraph(this.precipitationChartOptions)
    }
  }

  public solarRadationClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    let parent = target.parentElement
    let child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.solarRadationChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.solarRadationChartData.datasets[index].hidden === null || this.solarRadationChartData.datasets[index].hidden === false) {
      this.solarRadationChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.solarRadationChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    this.setSolarRadationScaleYPadding()
    let solarRadationGraph: any = this.$refs.solarRadationGraph
    if (solarRadationGraph !== undefined) {
      solarRadationGraph.updateGraph(this.solarRadationChartOptions)
    }
  }

  public temperatureClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.temperatureChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (index === 6 || index === 7) {
      let temperatureDifferenceIndex = 0
      if (index === 7) {
        temperatureDifferenceIndex = 1
      }
      if (this.temperatureDifferenceChartData.datasets[temperatureDifferenceIndex].hidden === null || this.temperatureDifferenceChartData.datasets[temperatureDifferenceIndex].hidden === false) {
        this.temperatureDifferenceChartData.datasets[temperatureDifferenceIndex].hidden = true
        target.classList.add('hidden')
      } else {
        this.temperatureDifferenceChartData.datasets[temperatureDifferenceIndex].hidden = false
        target.classList.remove('hidden')
      }

      this.setTemperatureDifferenceScaleYPadding()

      let temperatureDifferenceGraph: any = this.$refs.temperatureDifferenceGraph
      if (temperatureDifferenceGraph !== undefined) {
        temperatureDifferenceGraph.updateGraph()
      }
    } else {
      if (this.temperatureChartData.datasets[index].hidden === null || this.temperatureChartData.datasets[index].hidden === false) {
        this.temperatureChartData.datasets[index].hidden = true
        target.classList.add('hidden')
      } else {
        this.temperatureChartData.datasets[index].hidden = false
        target.classList.remove('hidden')
      }

      this.setTemperatureScaleYPadding()

      let temperatureGraph: any = this.$refs.temperatureGraph
      if (temperatureGraph !== undefined) {
        temperatureGraph.updateGraph()
      }
    }
  }

  public weedGrowthClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    let parent = target.parentElement
    let child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    if (this.weedGrowthChartData.datasets[index].hidden === null || this.weedGrowthChartData.datasets[index].hidden === false) {
      this.weedGrowthChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.weedGrowthChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    let weedGrowthGraph: any = this.$refs.weedGrowthGraph
    if (weedGrowthGraph !== undefined) {
      weedGrowthGraph.updateGraph(this.weedGrowthChartOptions)
    }
  }

  private setAreaScaleYPadding () {
    let scaleMax = 10 // 目盛り初期値
    let tmpMax = 0
    let areaChartData = this.areaChartData.datasets
    for (let chartData of areaChartData) {
      if (chartData.hidden) {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }
      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.areaChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length)
  }

  private setPredictionScaleYPadding () {
    let scaleMax = 1000 // 目盛り初期値
    let tmpMax = 0
    for (let chartData of this.predictionChartData.datasets) {
      if (chartData.hidden) {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }
      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.precipitationChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length)
  }

  private setSolarRadationScaleYPadding () {
    let scaleMax = 40 // 目盛り初期値
    let tmpMax = 0
    for (let chartData of this.solarRadationChartData.datasets) {
      if (chartData.hidden || chartData.yAxisID === 'yAxis_2') {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }
      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }

    scaleMax = parseInt(scaleMax.toString())
    this.solarRadationChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length)
  }

  private setTemperatureScaleYPadding () {
    let scaleMax = 40 // 目盛り初期値
    let tmpMax = 0
    for (let chartData of this.temperatureChartData.datasets) {
      if (chartData.hidden) {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }

      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.temperatureChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length, 'temperature')
  }

  private setTemperatureDifferenceScaleYPadding () {
    let scaleMax = 40 // 目盛り初期値
    let tmpMax = 0
    for (let chartData of this.temperatureDifferenceChartData.datasets) {
      if (chartData.hidden) {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }

      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.temperatureDifferenceChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length)
  }

  private getPaddingLeftFromScaleY (digit: any, key = '') {
    if (digit === 4) {
      return 12
    }
    if (digit === 3) {
      return 20
    }
    if (digit === 2) {
      // 気温グラフは最低値が-20で2.5文字のため調整
      if (key === 'temperature') {
        return 24
      } else {
        return 28
      }
    }
  }

  /* 実績グラフのデータを抽出 */
  private createdActualResultsData (key: string) {
    let actualResultsData: any = JSON.parse(Session.getGraphData()!)
    const data: any[] = []

    // データがない場合は空を返す
    if (actualResultsData === null) {
      return []
    }

    for (var j in this.label) {
      let day = '' + this.label[j].getFullYear() + DateClass.toDoubleDigits(this.label[j].getMonth() + 1) + DateClass.toDoubleDigits(this.label[j].getDate())

      if (actualResultsData[day] !== undefined) {
        data.push(actualResultsData[day][key])
      } else {
        data.push(null)
      }
    }

    return data
  }

  /* 目標グラフのデータを抽出 */
  private createdGoalData (key: string) {
    let masterData: any = {}

    if (key === 'water_contain_rate') {
      masterData = JSON.parse(Session.getMasterWaterLevelData()!)
    } else if (key === 'solar_radation') {
      masterData = JSON.parse(Session.getMasterSolarRadationData()!)
    } else {
      masterData = JSON.parse(Session.getMasterData()!)
    }
    const goalArray: any[] = []

    // 目標データがない場合は空を返す
    if (masterData === null) {
      return []
    }

    for (var j in this.label) {
      let day = '' + this.label[j].getFullYear() + DateClass.toDoubleDigits(this.label[j].getMonth() + 1) + DateClass.toDoubleDigits(this.label[j].getDate())

      if (masterData[day] !== undefined) {
        goalArray.push(masterData[day][key])
      } else {
        goalArray.push(null)
      }
    }

    /*
     * 播種日のデータがnullの場合は0を挿入
     * (ラベルデータの先頭10個は空データなので[9]を指定/goalArray[9]=播種日のデータ)
    */
    if (goalArray[9] === null) {
      goalArray[9] = 0
    }
    return goalArray
  }

  /* 予測グラフのデータを抽出 */
  private createdPredictionData (key: string) {
    let predictionData: any = JSON.parse(Session.getPredictionData()!)
    const data: any[] = []

    // データがない場合は空を返す
    if (predictionData === null) {
      return []
    }

    for (var j in this.label) {
      let day = '' + this.label[j].getFullYear() + DateClass.toDoubleDigits(this.label[j].getMonth() + 1) + DateClass.toDoubleDigits(this.label[j].getDate())

      if (predictionData[day] !== undefined) {
        data.push(predictionData[day][key])
      } else {
        data.push(null)
      }
    }

    return data
  }

  private getChartMaxValue () {
    const max = (identity: any, num: any) => num > identity ? num : identity
    let temperatureMaxs = []
    let elementMaxs = []
    let elementMaxs1 = []
    let elementMaxs2 = []
    let elementMaxs3 = []
    let elementMaxs4 = []
    let weedGrowthMaxs = []

    // 積算温度
    temperatureMaxs.push(this.createdActualResultsData('integration_temperature').reduce(max, -Infinity))
    temperatureMaxs.push(this.createdGoalData('goal_integration_temperature').reduce(max, -Infinity))
    temperatureMaxs.push(this.createPredictionTemperature().reduce(max, -Infinity))

    // 雑草丈
    weedGrowthMaxs.push(this.createWeedGrowth().reduce(max, -Infinity))
    weedGrowthMaxs.push(this.createPreWeedGrowth().reduce(max, -Infinity))

    const temperatureMax = temperatureMaxs.reduce(max, -Infinity)
    if (temperatureMax === 0 || temperatureMax === null || !isFinite(temperatureMax)) {
      this.temperatureYMax = 4000
    } else {
      let val = Math.floor(temperatureMax / 15)
      if (temperatureMax % 15 > 0) {
        val += 1
      }
      this.temperatureYMax = val * 5 * 4
    }
    this.chartOptions.scales.yAxes[0].ticks.max = this.temperatureYMax
    this.chartOptions.scales.yAxes[0].ticks.stepSize = this.temperatureYMax / 4

    const isYaxis1: string = process.env.VUE_APP_ELEMENT1_YAXIS
    const isYaxis2: string = process.env.VUE_APP_ELEMENT2_YAXIS
    const isYaxis3: string = process.env.VUE_APP_ELEMENT3_YAXIS
    const isYaxis4: string = process.env.VUE_APP_ELEMENT4_YAXIS

    if (isYaxis1 === 'true') {
      // element1
      elementMaxs1.push(this.createdActualResultsData('element1').reduce(max, -Infinity))
      elementMaxs1.push(this.createdGoalData('goal_element1').reduce(max, -Infinity))
    } else {
      // element1
      elementMaxs.push(this.createdActualResultsData('element1').reduce(max, -Infinity))
      elementMaxs.push(this.createdGoalData('goal_element1').reduce(max, -Infinity))
    }
    if (isYaxis2 === 'true') {
      // element2
      elementMaxs2.push(this.createdActualResultsData('element2').reduce(max, -Infinity))
      elementMaxs2.push(this.createdGoalData('goal_element2').reduce(max, -Infinity))
    } else {
      // element2
      elementMaxs.push(this.createdActualResultsData('element2').reduce(max, -Infinity))
      elementMaxs.push(this.createdGoalData('goal_element2').reduce(max, -Infinity))
    }

    if (isYaxis3 === 'true') {
      // element3
      elementMaxs3.push(this.createdActualResultsData('element3').reduce(max, -Infinity))
      elementMaxs3.push(this.createdGoalData('goal_element3').reduce(max, -Infinity))
    } else {
      // element3
      elementMaxs.push(this.createdActualResultsData('element3').reduce(max, -Infinity))
      elementMaxs.push(this.createdGoalData('goal_element3').reduce(max, -Infinity))
    }

    if (isYaxis4 === 'true') {
      // element4
      elementMaxs4.push(this.createdActualResultsData('element4').reduce(max, -Infinity))
      elementMaxs4.push(this.createdGoalData('goal_element4').reduce(max, -Infinity))
    } else {
      // element4
      elementMaxs.push(this.createdActualResultsData('element4').reduce(max, -Infinity))
      elementMaxs.push(this.createdGoalData('goal_element4').reduce(max, -Infinity))
    }

    const elementMax = elementMaxs.reduce(max, -Infinity)
    if (elementMax === 0 || elementMax === null || !isFinite(elementMax)) {
      this.elementYMax = 100
    } else {
      let val = Math.floor(elementMax / 15)
      if (elementMax % 15 > 0) {
        val += 1
      }
      this.elementYMax = val * 5 * 4
    }
    this.chartOptions.scales.yAxes[1].ticks.max = this.elementYMax
    this.chartOptions.scales.yAxes[1].ticks.stepSize = this.elementYMax / 4

    if (isYaxis1 === 'true') {
      const elementMax1 = elementMaxs1.reduce(max, -Infinity)
      if (elementMax1 === 0 || elementMax1 === null || !isFinite(elementMax1)) {
        this.elementYMax1 = 100
      } else {
        let val = Math.floor(elementMax1 / 3)
        if (elementMax1 % 3 > 0) {
          val += 1
        }
        this.elementYMax1 = val * 4
      }
      this.chartOptions.scales.yAxes[2].ticks.max = this.elementYMax1
      this.chartOptions.scales.yAxes[2].ticks.stepSize = this.elementYMax1 / 4
    }

    if (isYaxis2 === 'true') {
      const elementMax2 = elementMaxs2.reduce(max, -Infinity)
      if (elementMax2 === 0 || elementMax2 === null || !isFinite(elementMax2)) {
        this.elementYMax2 = 100
      } else {
        let val = Math.floor(elementMax2 / 3)
        if (elementMax2 % 3 > 0) {
          val += 1
        }
        this.elementYMax2 = val * 4
      }
      this.chartOptions.scales.yAxes[3].ticks.max = this.elementYMax2
      this.chartOptions.scales.yAxes[3].ticks.stepSize = this.elementYMax2 / 4
    }

    if (isYaxis3 === 'true') {
      const elementMax3 = elementMaxs3.reduce(max, -Infinity)
      if (elementMax3 === 0 || elementMax3 === null || !isFinite(elementMax3)) {
        this.elementYMax3 = 100
      } else {
        let val = Math.floor(elementMax3 / 3)
        if (elementMax3 % 3 > 0) {
          val += 1
        }
        this.elementYMax3 = val * 4
      }
      this.chartOptions.scales.yAxes[4].ticks.max = this.elementYMax3
      this.chartOptions.scales.yAxes[4].ticks.stepSize = this.elementYMax3 / 4
    }

    if (isYaxis4 === 'true') {
      const elementMax4 = elementMaxs4.reduce(max, -Infinity)
      if (elementMax4 === 0 || elementMax4 === null || !isFinite(elementMax4)) {
        this.elementYMax4 = 100
      } else {
        let val = Math.floor(elementMax4 / 3)
        if (elementMax4 % 3 > 0) {
          val += 1
        }
        this.elementYMax4 = val * 4
      }
      this.chartOptions.scales.yAxes[5].ticks.max = this.elementYMax4
      this.chartOptions.scales.yAxes[5].ticks.stepSize = this.elementYMax4 / 4
    }

    const weedGrowthMax = weedGrowthMaxs.reduce(max, -Infinity)
    if (weedGrowthMax === 0 || weedGrowthMax === null || !isFinite(weedGrowthMax)) {
      this.weedGrowthYMax = 150
    } else {
      let val = Math.floor(weedGrowthMax / 15)
      if (weedGrowthMax % 15 > 0) {
        val += 1
      }
      this.weedGrowthYMax = val * 5 * 6
    }
    this.weedGrowthChartOptions.scales.yAxes[0].ticks.max = this.weedGrowthYMax
    this.weedGrowthChartOptions.scales.yAxes[0].ticks.stepSize = this.weedGrowthYMax / 3

    // プログレスバーが他のグラフとズレないように調整
    const temperatureYMaxLength = this.temperatureYMax.toString()
    if (temperatureYMaxLength.length === 1) {
      this.chartOptions.layout.padding.right = 43
    } else if (temperatureYMaxLength.length === 2) {
      this.chartOptions.layout.padding.right = 35
    } else if (temperatureYMaxLength.length === 3) {
      this.chartOptions.layout.padding.right = 30
    } else if (temperatureYMaxLength.length === 4) {
      this.chartOptions.layout.padding.right = 22
    }

    const elementYMaxLength = this.elementYMax.toString()
    if (elementYMaxLength.length === 1) {
      this.chartOptions.layout.padding.left = 34
    } else if (elementYMaxLength.length === 2) {
      this.chartOptions.layout.padding.left = 27
    } else if (elementYMaxLength.length === 3) {
      this.chartOptions.layout.padding.left = 19
    } else if (elementYMaxLength.length === 4) {
      this.chartOptions.layout.padding.left = 16
    }

    const weedGrowthYMaxLength = this.weedGrowthYMax.toString()
    if (weedGrowthYMaxLength.length === 2) {
      this.weedGrowthChartOptions.layout.padding.left = 28
    } else if (weedGrowthYMaxLength.length === 3) {
      this.weedGrowthChartOptions.layout.padding.left = 20
    }
  }

  /* 生育ステージ一覧モーダル */
  private showStageListModal () {
    this.$emit('show-stage-list-modal', true)
  }

  private createMachineRent () {
    // 機械貸出画面に遷移
    this.$store.commit('machineRentState/setInitialFieldId', parseInt(this.$route.params.field_id))
    this.$router.push('/machine-rent/create').catch(e => {})
  }

  private hoverRentNumber: number = 0

  private mouseOver (rentId: number) {
    this.hoverRentNumber = rentId
  }

  private mouseLeave (rentId: number) {
    this.hoverRentNumber = 0
  }

  private toRentDietails (id: any) {
    this.$router.push('/machine-rent/' + id).catch(e => {})
  }

  private judgeStatusIconClass (rentId: number) {
    let rentIds: any = []
    for (let k in this.weedGrowthData.machine_rent) {
      if (rentIds.includes(this.weedGrowthData.machine_rent[k].machine_rent_id) !== -1) {
        rentIds.push(this.weedGrowthData.machine_rent[k].machine_rent_id)
      }
    }
    const filteredArray = rentIds.filter(function (a: any, b: any) {
      return rentIds.indexOf(a) === b
    })
    const number = filteredArray.findIndex((c: any) => {
      return c === rentId
    })

    let classNumber
    if (number > 12) {
      classNumber = number - 12
    } else if (number > 6) {
      classNumber = number - 6
    } else {
      classNumber = number + 1
    }

    return 'rent-color' + classNumber
  }
}
